
var Rive = (() => {
  var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;
  
  return (
function(moduleArg = {}) {

var k = moduleArg, aa, ca;
k.ready = new Promise((a, b) => {
  aa = a;
  ca = b;
});
function da() {
  function a(g) {
    const l = d;
    c = b = 0;
    d = new Map();
    l.forEach(p => {
      try {
        p(g);
      } catch (m) {
        console.error(m);
      }
    });
    this.ob();
    e && e.Qb();
  }
  let b = 0, c = 0, d = new Map(), e = null, f = null;
  this.requestAnimationFrame = function(g) {
    b || (b = requestAnimationFrame(a.bind(this)));
    const l = ++c;
    d.set(l, g);
    return l;
  };
  this.cancelAnimationFrame = function(g) {
    d.delete(g);
    b && 0 == d.size && (cancelAnimationFrame(b), b = 0);
  };
  this.Ob = function(g) {
    f && (document.body.remove(f), f = null);
    g || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", g = function(l) {
      f.innerHTML = "RIVE FPS " + l.toFixed(1);
    }, document.body.appendChild(f));
    e = new function() {
      let l = 0, p = 0;
      this.Qb = function() {
        var m = performance.now();
        p ? (++l, m -= p, 1000 < m && (g(1000 * l / m), l = p = 0)) : (p = m, l = 0);
      };
    }();
  };
  this.ob = function() {
  };
}
function ea() {
  console.assert(!0);
  const a = new Map();
  let b = -Infinity;
  this.push = function(c) {
    c = c + 255 >> 8;
    a.has(c) && clearTimeout(a.get(c));
    a.set(c, setTimeout(function() {
      a.delete(c);
      0 == a.length ? b = -Infinity : c == b && (b = Math.max(...a.keys()), console.assert(b < c));
    }, 1000));
    b = Math.max(c, b);
    return b << 8;
  };
}
const fa = k.onRuntimeInitialized;
k.onRuntimeInitialized = function() {
  fa && fa();
  let a = k.decodeAudio;
  k.decodeAudio = function(e, f) {
    e = a(e);
    f(e);
  };
  let b = k.decodeFont;
  k.decodeFont = function(e, f) {
    e = b(e);
    f(e);
  };
  const c = k.FileAssetLoader;
  k.ptrToAsset = e => {
    let f = k.ptrToFileAsset(e);
    return f.isImage ? k.ptrToImageAsset(e) : f.isFont ? k.ptrToFontAsset(e) : f.isAudio ? k.ptrToAudioAsset(e) : f;
  };
  k.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {__construct:function({loadContents:e}) {
    this.__parent.__construct.call(this);
    this.Eb = e;
  }, loadContents:function(e, f) {
    e = k.ptrToAsset(e);
    return this.Eb(e, f);
  },});
  k.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
  }, loadContents:function(e) {
    let f = k.ptrToAsset(e);
    e = f.cdnUuid;
    if ("" === e) {
      return !1;
    }
    (function(g, l) {
      var p = new XMLHttpRequest();
      p.responseType = "arraybuffer";
      p.onreadystatechange = function() {
        4 == p.readyState && 200 == p.status && l(p);
      };
      p.open("GET", g, !0);
      p.send(null);
    })(f.cdnBaseUrl + "/" + e, g => {
      f.decode(new Uint8Array(g.response));
    });
    return !0;
  },});
  k.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
    this.kb = [];
  }, addLoader:function(e) {
    this.kb.push(e);
  }, loadContents:function(e, f) {
    for (let g of this.kb) {
      if (g.loadContents(e, f)) {
        return !0;
      }
    }
    return !1;
  },});
  let d = k.computeAlignment;
  k.computeAlignment = function(e, f, g, l, p = 1.0) {
    return d.call(this, e, f, g, l, p);
  };
};
const ha = k.onRuntimeInitialized;
k.onRuntimeInitialized = function() {
  function a(r) {
    this.F = r;
    this.Db = r.getContext("2d");
    this.Gb = d;
    this.S = [];
    this.la = 0;
    this.clear = function() {
      console.assert(0 == this.la);
      this.S = [];
      e.delete(this);
    };
    this.save = function() {
      ++this.la;
      this.S.push(d.save.bind(d));
    };
    this.restore = function() {
      0 < this.la && (this.S.push(d.restore.bind(d)), --this.la);
    };
    this.transform = function(u) {
      this.S.push(d.transform.bind(d, u));
    };
    this.align = function(u, y, z, B, H = 1.0) {
      this.S.push(d.align.bind(d, u, y, z, B, H));
    };
    this.flush = function() {
      console.assert(0 == this.la);
      e.add(this);
      d.$a || c();
    };
    this["delete"] = function() {
    };
  }
  function b(r, u = !1) {
    var y = {alpha:!0, depth:u, stencil:u, antialias:u, premultipliedAlpha:!0, preserveDrawingBuffer:0, powerPreference:"high-performance", failIfMajorPerformanceCaveat:0, enableExtensionsByDefault:!1, explicitSwapControl:0, renderViaOffscreenBackBuffer:0,};
    u = r.getContext("webgl2", y);
    if (!u) {
      return null;
    }
    y = ia(u, y);
    ja(y);
    const z = f(r.width, r.height);
    z.Na = y;
    z.F = r;
    z.Oa = r.width;
    z.ab = r.height;
    z.T = u;
    var B = z.delete;
    z.delete = function() {
      B.call(this);
      var H = this.Na;
      q === w[H] && (q = null);
      "object" == typeof JSEvents && JSEvents.Oc(w[H].C.canvas);
      w[H] && w[H].C.canvas && (w[H].C.canvas.Cb = void 0);
      this.Na = this.F = this.Oa = this.T = w[H] = null;
    };
    return z;
  }
  function c() {
    if (d) {
      var r = d.Fb, u = 0, y = 0, z = 0, B = Array(e.size), H = 0;
      for (var J of e) {
        J.ga = Math.min(J.F.width, r), J.fa = Math.min(J.F.height, r), J.La = J.fa * J.ga, u = Math.max(u, J.ga), y = Math.max(y, J.fa), z += J.La, B[H++] = J;
      }
      e.clear();
      if (!(0 >= z)) {
        u = 1 << (0 >= u ? 0 : 32 - Math.clz32(u - 1));
        for (y = 1 << (0 >= y ? 0 : 32 - Math.clz32(y - 1)); y * u < z;) {
          u <= y ? u *= 2 : y *= 2;
        }
        u = Math.min(u, r);
        u = Math.min(y, r);
        B.sort((ba, tb) => tb.La - ba.La);
        z = new k.DynamicRectanizer(r);
        for (J = 0; J < B.length;) {
          z.reset(u, y);
          for (H = J; H < B.length; ++H) {
            var L = B[H], E = z.addRect(L.ga, L.fa);
            if (0 > E) {
              console.assert(H > J);
              break;
            }
            L.ra = E & 65535;
            L.sa = E >> 16;
          }
          L = p.push(z.drawWidth());
          E = m.push(z.drawHeight());
          console.assert(L >= z.drawWidth());
          console.assert(E >= z.drawHeight());
          console.assert(L <= r);
          console.assert(E <= r);
          d.F.width != L && (d.F.width = L);
          d.F.height != E && (d.F.height = E);
          d.clear();
          for (L = J; L < H; ++L) {
            E = B[L];
            d.saveClipRect(E.ra, E.sa, E.ra + E.ga, E.sa + E.fa);
            let ba = new k.Mat2D();
            ba.xx = E.ga / E.F.width;
            ba.yy = E.fa / E.F.height;
            ba.xy = ba.yx = 0;
            ba.tx = E.ra;
            ba.ty = E.sa;
            d.transform(ba);
            for (const tb of E.S) {
              tb();
            }
            d.restoreClipRect();
            E.S = [];
          }
          for (d.flush(); J < H; ++J) {
            L = B[J], E = L.Db, E.globalCompositeOperation = "copy", E.drawImage(d.F, L.ra, L.sa, L.ga, L.fa, 0, 0, L.F.width, L.F.height);
          }
          J = H;
        }
      }
    }
  }
  ha && ha();
  let d = null;
  const e = new Set(), f = k.makeRenderer;
  k.makeRenderer = function(r, u) {
    if (!d) {
      function y(z) {
        var B = document.createElement("canvas");
        B.width = 1;
        B.height = 1;
        d = b(B, z);
        d.$a = !!d.T.getExtension("WEBGL_shader_pixel_local_storage");
        d.Fb = Math.min(d.T.getParameter(d.T.MAX_RENDERBUFFER_SIZE), d.T.getParameter(d.T.MAX_TEXTURE_SIZE));
        d.Ma = !d.$a;
        if (z = d.T.getExtension("WEBGL_debug_renderer_info")) {
          B = d.T.getParameter(z.UNMASKED_RENDERER_WEBGL), d.T.getParameter(z.UNMASKED_VENDOR_WEBGL).includes("Google") && B.includes("ANGLE Metal Renderer") && (d.Ma = !1);
        }
        return d;
      }
      d = y(!0);
      d.Ma || (d = y(!1));
    }
    return u ? new a(r) : b(r, d.Ma);
  };
  const g = k.Artboard.prototype["delete"];
  k.Artboard.prototype["delete"] = function() {
    this.Hb = !0;
    g.call(this);
  };
  const l = k.Artboard.prototype.draw;
  k.Artboard.prototype.draw = function(r) {
    r.S ? r.S.push(() => {
      this.Hb || l.call(this, r.Gb);
    }) : l.call(this, r);
  };
  const p = new ea(), m = new ea(), t = new da();
  k.requestAnimationFrame = t.requestAnimationFrame.bind(t);
  k.cancelAnimationFrame = t.cancelAnimationFrame.bind(t);
  k.enableFPSCounter = t.Ob.bind(t);
  t.ob = c;
  k.resolveAnimationFrame = c;
  let v = k.load;
  k.load = function(r, u, y = !0) {
    const z = new k.FallbackFileAssetLoader();
    void 0 !== u && z.addLoader(u);
    y && (u = new k.CDNFileAssetLoader(), z.addLoader(u));
    return Promise.resolve(v(r, z));
  };
  const x = k.WebGL2Renderer.prototype.clear;
  k.WebGL2Renderer.prototype.clear = function() {
    ja(this.Na);
    const r = this.F;
    if (this.Oa != r.width || this.ab != r.height) {
      this.resize(r.width, r.height), this.Oa = r.width, this.ab = r.height;
    }
    x.call(this);
  };
  k.decodeImage = function(r, u) {
    r = k.decodeWebGL2Image(r);
    u(r);
  };
  let n = k.Renderer.prototype.align;
  k.Renderer.prototype.align = function(r, u, y, z, B = 1.0) {
    n.call(this, r, u, y, z, B);
  };
};
var ka = Object.assign({}, k), la = "./this.program", ma = "object" == typeof window, na = "function" == typeof importScripts, A = "", oa, pa;
if (ma || na) {
  na ? A = self.location.href : "undefined" != typeof document && document.currentScript && (A = document.currentScript.src), _scriptDir && (A = _scriptDir), 0 !== A.indexOf("blob:") ? A = A.substr(0, A.replace(/[?#].*/, "").lastIndexOf("/") + 1) : A = "", na && (pa = a => {
    var b = new XMLHttpRequest();
    b.open("GET", a, !1);
    b.responseType = "arraybuffer";
    b.send(null);
    return new Uint8Array(b.response);
  }), oa = (a, b, c) => {
    var d = new XMLHttpRequest();
    d.open("GET", a, !0);
    d.responseType = "arraybuffer";
    d.onload = () => {
      200 == d.status || 0 == d.status && d.response ? b(d.response) : c();
    };
    d.onerror = c;
    d.send(null);
  };
}
var qa = k.print || console.log.bind(console), ra = k.printErr || console.error.bind(console);
Object.assign(k, ka);
ka = null;
k.thisProgram && (la = k.thisProgram);
var sa;
k.wasmBinary && (sa = k.wasmBinary);
var noExitRuntime = k.noExitRuntime || !0;
"object" != typeof WebAssembly && ta("no native wasm support detected");
var ua, C, va = !1, D, F, G, wa, I, K, xa, ya;
function za() {
  var a = ua.buffer;
  k.HEAP8 = D = new Int8Array(a);
  k.HEAP16 = G = new Int16Array(a);
  k.HEAP32 = I = new Int32Array(a);
  k.HEAPU8 = F = new Uint8Array(a);
  k.HEAPU16 = wa = new Uint16Array(a);
  k.HEAPU32 = K = new Uint32Array(a);
  k.HEAPF32 = xa = new Float32Array(a);
  k.HEAPF64 = ya = new Float64Array(a);
}
var Aa, Ba = [], Ca = [], Da = [];
function Ea() {
  var a = k.preRun.shift();
  Ba.unshift(a);
}
var Fa = 0, Ga = null, Ha = null;
function ta(a) {
  if (k.onAbort) {
    k.onAbort(a);
  }
  a = "Aborted(" + a + ")";
  ra(a);
  va = !0;
  a = new WebAssembly.RuntimeError(a + ". Build with -sASSERTIONS for more info.");
  ca(a);
  throw a;
}
function Ia(a) {
  return a.startsWith("data:application/octet-stream;base64,");
}
var Ja;
Ja = "webgl2_advanced.wasm";
if (!Ia(Ja)) {
  var Ka = Ja;
  Ja = k.locateFile ? k.locateFile(Ka, A) : A + Ka;
}
function La(a) {
  if (a == Ja && sa) {
    return new Uint8Array(sa);
  }
  if (pa) {
    return pa(a);
  }
  throw "both async and sync fetching of the wasm failed";
}
function Ma(a) {
  if (!sa && (ma || na)) {
    if ("function" == typeof fetch && !a.startsWith("file://")) {
      return fetch(a, {credentials:"same-origin"}).then(b => {
        if (!b.ok) {
          throw "failed to load wasm binary file at '" + a + "'";
        }
        return b.arrayBuffer();
      }).catch(() => La(a));
    }
    if (oa) {
      return new Promise((b, c) => {
        oa(a, d => b(new Uint8Array(d)), c);
      });
    }
  }
  return Promise.resolve().then(() => La(a));
}
function Na(a, b, c) {
  return Ma(a).then(d => WebAssembly.instantiate(d, b)).then(d => d).then(c, d => {
    ra("failed to asynchronously prepare wasm: " + d);
    ta(d);
  });
}
function Oa(a, b) {
  var c = Ja;
  return sa || "function" != typeof WebAssembly.instantiateStreaming || Ia(c) || c.startsWith("file://") || "function" != typeof fetch ? Na(c, a, b) : fetch(c, {credentials:"same-origin"}).then(d => WebAssembly.instantiateStreaming(d, a).then(b, function(e) {
    ra("wasm streaming compile failed: " + e);
    ra("falling back to ArrayBuffer instantiation");
    return Na(c, a, b);
  }));
}
var Pa, Qa, Ua = {535063:(a, b, c, d, e) => {
  if ("undefined" === typeof window || void 0 === (window.AudioContext || window.webkitAudioContext)) {
    return 0;
  }
  if ("undefined" === typeof window.h) {
    window.h = {Ga:0};
    window.h.I = {};
    window.h.I.Ea = a;
    window.h.I.capture = b;
    window.h.I.Ra = c;
    window.h.ja = {};
    window.h.ja.stopped = d;
    window.h.ja.xb = e;
    let f = window.h;
    f.D = [];
    f.rc = function(g) {
      for (var l = 0; l < f.D.length; ++l) {
        if (null == f.D[l]) {
          return f.D[l] = g, l;
        }
      }
      f.D.push(g);
      return f.D.length - 1;
    };
    f.Bb = function(g) {
      for (f.D[g] = null; 0 < f.D.length;) {
        if (null == f.D[f.D.length - 1]) {
          f.D.pop();
        } else {
          break;
        }
      }
    };
    f.Qc = function(g) {
      for (var l = 0; l < f.D.length; ++l) {
        if (f.D[l] == g) {
          return f.Bb(l);
        }
      }
    };
    f.va = function(g) {
      return f.D[g];
    };
    f.Za = ["touchend", "click"];
    f.unlock = function() {
      for (var g = 0; g < f.D.length; ++g) {
        var l = f.D[g];
        null != l && null != l.J && l.state === f.ja.xb && l.J.resume().then(() => {
          Ra(l.pb);
        }, p => {
          console.error("Failed to resume audiocontext", p);
        });
      }
      f.Za.map(function(p) {
        document.removeEventListener(p, f.unlock, !0);
      });
    };
    f.Za.map(function(g) {
      document.addEventListener(g, f.unlock, !0);
    });
  }
  window.h.Ga += 1;
  return 1;
}, 537241:() => {
  "undefined" !== typeof window.h && (window.h.Za.map(function(a) {
    document.removeEventListener(a, window.h.unlock, !0);
  }), --window.h.Ga, 0 === window.h.Ga && delete window.h);
}, 537545:() => void 0 !== navigator.mediaDevices && void 0 !== navigator.mediaDevices.getUserMedia, 537649:() => {
  try {
    var a = new (window.AudioContext || window.webkitAudioContext)(), b = a.sampleRate;
    a.close();
    return b;
  } catch (c) {
    return 0;
  }
}, 537820:(a, b, c, d, e, f) => {
  if ("undefined" === typeof window.h) {
    return -1;
  }
  var g = {}, l = {};
  a == window.h.I.Ea && 0 != c && (l.sampleRate = c);
  g.J = new (window.AudioContext || window.webkitAudioContext)(l);
  g.J.suspend();
  g.state = window.h.ja.stopped;
  c = 0;
  a != window.h.I.Ea && (c = b);
  g.Z = g.J.createScriptProcessor(d, c, b);
  g.Z.onaudioprocess = function(p) {
    if (null == g.wa || 0 == g.wa.length) {
      g.wa = new Float32Array(xa.buffer, e, d * b);
    }
    if (a == window.h.I.capture || a == window.h.I.Ra) {
      for (var m = 0; m < b; m += 1) {
        for (var t = p.inputBuffer.getChannelData(m), v = g.wa, x = 0; x < d; x += 1) {
          v[x * b + m] = t[x];
        }
      }
      Sa(f, d, e);
    }
    if (a == window.h.I.Ea || a == window.h.I.Ra) {
      for (Ta(f, d, e), m = 0; m < p.outputBuffer.numberOfChannels; ++m) {
        for (t = p.outputBuffer.getChannelData(m), v = g.wa, x = 0; x < d; x += 1) {
          t[x] = v[x * b + m];
        }
      }
    } else {
      for (m = 0; m < p.outputBuffer.numberOfChannels; ++m) {
        p.outputBuffer.getChannelData(m).fill(0.0);
      }
    }
  };
  a != window.h.I.capture && a != window.h.I.Ra || navigator.mediaDevices.getUserMedia({audio:!0, video:!1}).then(function(p) {
    g.Ha = g.J.createMediaStreamSource(p);
    g.Ha.connect(g.Z);
    g.Z.connect(g.J.destination);
  }).catch(function(p) {
    console.log("Failed to get user media: " + p);
  });
  a == window.h.I.Ea && g.Z.connect(g.J.destination);
  g.pb = f;
  return window.h.rc(g);
}, 540697:a => window.h.va(a).J.sampleRate, 540770:a => {
  a = window.h.va(a);
  void 0 !== a.Z && (a.Z.onaudioprocess = function() {
  }, a.Z.disconnect(), a.Z = void 0);
  void 0 !== a.Ha && (a.Ha.disconnect(), a.Ha = void 0);
  a.J.close();
  a.J = void 0;
  a.pb = void 0;
}, 541170:a => {
  window.h.Bb(a);
}, 541220:a => {
  a = window.h.va(a);
  a.J.resume();
  a.state = window.h.ja.xb;
}, 541359:a => {
  a = window.h.va(a);
  a.J.suspend();
  a.state = window.h.ja.stopped;
}}, Va = a => {
  for (; 0 < a.length;) {
    a.shift()(k);
  }
}, Wa = (a, b) => {
  for (var c = 0, d = a.length - 1; 0 <= d; d--) {
    var e = a[d];
    "." === e ? a.splice(d, 1) : ".." === e ? (a.splice(d, 1), c++) : c && (a.splice(d, 1), c--);
  }
  if (b) {
    for (; c; c--) {
      a.unshift("..");
    }
  }
  return a;
}, Xa = a => {
  var b = "/" === a.charAt(0), c = "/" === a.substr(-1);
  (a = Wa(a.split("/").filter(d => !!d), !b).join("/")) || b || (a = ".");
  a && c && (a += "/");
  return (b ? "/" : "") + a;
}, Ya = a => {
  var b = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(a).slice(1);
  a = b[0];
  b = b[1];
  if (!a && !b) {
    return ".";
  }
  b && (b = b.substr(0, b.length - 1));
  return a + b;
}, Za = a => {
  if ("/" === a) {
    return "/";
  }
  a = Xa(a);
  a = a.replace(/\/$/, "");
  var b = a.lastIndexOf("/");
  return -1 === b ? a : a.substr(b + 1);
}, $a = () => {
  if ("object" == typeof crypto && "function" == typeof crypto.getRandomValues) {
    return a => crypto.getRandomValues(a);
  }
  ta("initRandomDevice");
}, ab = a => (ab = $a())(a);
function bb() {
  for (var a = "", b = !1, c = arguments.length - 1; -1 <= c && !b; c--) {
    b = 0 <= c ? arguments[c] : "/";
    if ("string" != typeof b) {
      throw new TypeError("Arguments to path.resolve must be strings");
    }
    if (!b) {
      return "";
    }
    a = b + "/" + a;
    b = "/" === b.charAt(0);
  }
  a = Wa(a.split("/").filter(d => !!d), !b).join("/");
  return (b ? "/" : "") + a || ".";
}
var cb = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, M = (a, b, c) => {
  var d = b + c;
  for (c = b; a[c] && !(c >= d);) {
    ++c;
  }
  if (16 < c - b && a.buffer && cb) {
    return cb.decode(a.subarray(b, c));
  }
  for (d = ""; b < c;) {
    var e = a[b++];
    if (e & 128) {
      var f = a[b++] & 63;
      if (192 == (e & 224)) {
        d += String.fromCharCode((e & 31) << 6 | f);
      } else {
        var g = a[b++] & 63;
        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | g : (e & 7) << 18 | f << 12 | g << 6 | a[b++] & 63;
        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
      }
    } else {
      d += String.fromCharCode(e);
    }
  }
  return d;
}, db = [], eb = a => {
  for (var b = 0, c = 0; c < a.length; ++c) {
    var d = a.charCodeAt(c);
    127 >= d ? b++ : 2047 >= d ? b += 2 : 55296 <= d && 57343 >= d ? (b += 4, ++c) : b += 3;
  }
  return b;
}, fb = (a, b, c, d) => {
  if (!(0 < d)) {
    return 0;
  }
  var e = c;
  d = c + d - 1;
  for (var f = 0; f < a.length; ++f) {
    var g = a.charCodeAt(f);
    if (55296 <= g && 57343 >= g) {
      var l = a.charCodeAt(++f);
      g = 65536 + ((g & 1023) << 10) | l & 1023;
    }
    if (127 >= g) {
      if (c >= d) {
        break;
      }
      b[c++] = g;
    } else {
      if (2047 >= g) {
        if (c + 1 >= d) {
          break;
        }
        b[c++] = 192 | g >> 6;
      } else {
        if (65535 >= g) {
          if (c + 2 >= d) {
            break;
          }
          b[c++] = 224 | g >> 12;
        } else {
          if (c + 3 >= d) {
            break;
          }
          b[c++] = 240 | g >> 18;
          b[c++] = 128 | g >> 12 & 63;
        }
        b[c++] = 128 | g >> 6 & 63;
      }
      b[c++] = 128 | g & 63;
    }
  }
  b[c] = 0;
  return c - e;
};
function gb(a, b) {
  var c = Array(eb(a) + 1);
  a = fb(a, c, 0, c.length);
  b && (c.length = a);
  return c;
}
var hb = [];
function ib(a, b) {
  hb[a] = {input:[], G:[], V:b};
  jb(a, kb);
}
var kb = {open:function(a) {
  var b = hb[a.node.Fa];
  if (!b) {
    throw new N(43);
  }
  a.s = b;
  a.seekable = !1;
}, close:function(a) {
  a.s.V.ua(a.s);
}, ua:function(a) {
  a.s.V.ua(a.s);
}, read:function(a, b, c, d) {
  if (!a.s || !a.s.V.jb) {
    throw new N(60);
  }
  for (var e = 0, f = 0; f < d; f++) {
    try {
      var g = a.s.V.jb(a.s);
    } catch (l) {
      throw new N(29);
    }
    if (void 0 === g && 0 === e) {
      throw new N(6);
    }
    if (null === g || void 0 === g) {
      break;
    }
    e++;
    b[c + f] = g;
  }
  e && (a.node.timestamp = Date.now());
  return e;
}, write:function(a, b, c, d) {
  if (!a.s || !a.s.V.Ua) {
    throw new N(60);
  }
  try {
    for (var e = 0; e < d; e++) {
      a.s.V.Ua(a.s, b[c + e]);
    }
  } catch (f) {
    throw new N(29);
  }
  d && (a.node.timestamp = Date.now());
  return e;
},}, lb = {jb:function() {
  a: {
    if (!db.length) {
      var a = null;
      "undefined" != typeof window && "function" == typeof window.prompt ? (a = window.prompt("Input: "), null !== a && (a += "\n")) : "function" == typeof readline && (a = readline(), null !== a && (a += "\n"));
      if (!a) {
        a = null;
        break a;
      }
      db = gb(a, !0);
    }
    a = db.shift();
  }
  return a;
}, Ua:function(a, b) {
  null === b || 10 === b ? (qa(M(a.G, 0)), a.G = []) : 0 != b && a.G.push(b);
}, ua:function(a) {
  a.G && 0 < a.G.length && (qa(M(a.G, 0)), a.G = []);
}, $b:function() {
  return {xc:25856, zc:5, wc:191, yc:35387, vc:[3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,]};
}, ac:function() {
  return 0;
}, bc:function() {
  return [24, 80];
},}, mb = {Ua:function(a, b) {
  null === b || 10 === b ? (ra(M(a.G, 0)), a.G = []) : 0 != b && a.G.push(b);
}, ua:function(a) {
  a.G && 0 < a.G.length && (ra(M(a.G, 0)), a.G = []);
},};
function nb(a, b) {
  var c = a.j ? a.j.length : 0;
  c >= b || (b = Math.max(b, c * (1048576 > c ? 2.0 : 1.125) >>> 0), 0 != c && (b = Math.max(b, 256)), c = a.j, a.j = new Uint8Array(b), 0 < a.v && a.j.set(c.subarray(0, a.v), 0));
}
var O = {O:null, U() {
  return O.createNode(null, "/", 16895, 0);
}, createNode(a, b, c, d) {
  if (24576 === (c & 61440) || 4096 === (c & 61440)) {
    throw new N(63);
  }
  O.O || (O.O = {dir:{node:{Y:O.l.Y, P:O.l.P, ma:O.l.ma, Ca:O.l.Ca, vb:O.l.vb, Ab:O.l.Ab, wb:O.l.wb, tb:O.l.tb, Ia:O.l.Ia}, stream:{ba:O.m.ba}}, file:{node:{Y:O.l.Y, P:O.l.P}, stream:{ba:O.m.ba, read:O.m.read, write:O.m.write, ta:O.m.ta, lb:O.m.lb, nb:O.m.nb}}, link:{node:{Y:O.l.Y, P:O.l.P, na:O.l.na}, stream:{}}, bb:{node:{Y:O.l.Y, P:O.l.P}, stream:ob}});
  c = pb(a, b, c, d);
  16384 === (c.mode & 61440) ? (c.l = O.O.dir.node, c.m = O.O.dir.stream, c.j = {}) : 32768 === (c.mode & 61440) ? (c.l = O.O.file.node, c.m = O.O.file.stream, c.v = 0, c.j = null) : 40960 === (c.mode & 61440) ? (c.l = O.O.link.node, c.m = O.O.link.stream) : 8192 === (c.mode & 61440) && (c.l = O.O.bb.node, c.m = O.O.bb.stream);
  c.timestamp = Date.now();
  a && (a.j[b] = c, a.timestamp = c.timestamp);
  return c;
}, Ec(a) {
  return a.j ? a.j.subarray ? a.j.subarray(0, a.v) : new Uint8Array(a.j) : new Uint8Array(0);
}, l:{Y(a) {
  var b = {};
  b.Cc = 8192 === (a.mode & 61440) ? a.id : 1;
  b.Gc = a.id;
  b.mode = a.mode;
  b.Lc = 1;
  b.uid = 0;
  b.Fc = 0;
  b.Fa = a.Fa;
  16384 === (a.mode & 61440) ? b.size = 4096 : 32768 === (a.mode & 61440) ? b.size = a.v : 40960 === (a.mode & 61440) ? b.size = a.link.length : b.size = 0;
  b.tc = new Date(a.timestamp);
  b.Jc = new Date(a.timestamp);
  b.Ac = new Date(a.timestamp);
  b.Ib = 4096;
  b.uc = Math.ceil(b.size / b.Ib);
  return b;
}, P(a, b) {
  void 0 !== b.mode && (a.mode = b.mode);
  void 0 !== b.timestamp && (a.timestamp = b.timestamp);
  if (void 0 !== b.size && (b = b.size, a.v != b)) {
    if (0 == b) {
      a.j = null, a.v = 0;
    } else {
      var c = a.j;
      a.j = new Uint8Array(b);
      c && a.j.set(c.subarray(0, Math.min(b, a.v)));
      a.v = b;
    }
  }
}, ma() {
  throw qb[44];
}, Ca(a, b, c, d) {
  return O.createNode(a, b, c, d);
}, vb(a, b, c) {
  if (16384 === (a.mode & 61440)) {
    try {
      var d = rb(b, c);
    } catch (f) {
    }
    if (d) {
      for (var e in d.j) {
        throw new N(55);
      }
    }
  }
  delete a.parent.j[a.name];
  a.parent.timestamp = Date.now();
  a.name = c;
  b.j[c] = a;
  b.timestamp = a.parent.timestamp;
  a.parent = b;
}, Ab(a, b) {
  delete a.j[b];
  a.timestamp = Date.now();
}, wb(a, b) {
  var c = rb(a, b), d;
  for (d in c.j) {
    throw new N(55);
  }
  delete a.j[b];
  a.timestamp = Date.now();
}, tb(a) {
  var b = [".", ".."], c;
  for (c in a.j) {
    a.j.hasOwnProperty(c) && b.push(c);
  }
  return b;
}, Ia(a, b, c) {
  a = O.createNode(a, b, 41471, 0);
  a.link = c;
  return a;
}, na(a) {
  if (40960 !== (a.mode & 61440)) {
    throw new N(28);
  }
  return a.link;
},}, m:{read(a, b, c, d, e) {
  var f = a.node.j;
  if (e >= a.node.v) {
    return 0;
  }
  a = Math.min(a.node.v - e, d);
  if (8 < a && f.subarray) {
    b.set(f.subarray(e, e + a), c);
  } else {
    for (d = 0; d < a; d++) {
      b[c + d] = f[e + d];
    }
  }
  return a;
}, write(a, b, c, d, e, f) {
  b.buffer === D.buffer && (f = !1);
  if (!d) {
    return 0;
  }
  a = a.node;
  a.timestamp = Date.now();
  if (b.subarray && (!a.j || a.j.subarray)) {
    if (f) {
      return a.j = b.subarray(c, c + d), a.v = d;
    }
    if (0 === a.v && 0 === e) {
      return a.j = b.slice(c, c + d), a.v = d;
    }
    if (e + d <= a.v) {
      return a.j.set(b.subarray(c, c + d), e), d;
    }
  }
  nb(a, e + d);
  if (a.j.subarray && b.subarray) {
    a.j.set(b.subarray(c, c + d), e);
  } else {
    for (f = 0; f < d; f++) {
      a.j[e + f] = b[c + f];
    }
  }
  a.v = Math.max(a.v, e + d);
  return d;
}, ba(a, b, c) {
  1 === c ? b += a.position : 2 === c && 32768 === (a.node.mode & 61440) && (b += a.node.v);
  if (0 > b) {
    throw new N(28);
  }
  return b;
}, ta(a, b, c) {
  nb(a.node, b + c);
  a.node.v = Math.max(a.node.v, b + c);
}, lb(a, b, c, d, e) {
  if (32768 !== (a.node.mode & 61440)) {
    throw new N(43);
  }
  a = a.node.j;
  if (e & 2 || a.buffer !== D.buffer) {
    if (0 < c || c + b < a.length) {
      a.subarray ? a = a.subarray(c, c + b) : a = Array.prototype.slice.call(a, c, c + b);
    }
    c = !0;
    ta();
    b = void 0;
    if (!b) {
      throw new N(48);
    }
    D.set(a, b);
  } else {
    c = !1, b = a.byteOffset;
  }
  return {o:b, M:c};
}, nb(a, b, c, d) {
  O.m.write(a, b, 0, d, c, !1);
  return 0;
},},};
function sb(a, b) {
  var c = 0;
  a && (c |= 365);
  b && (c |= 146);
  return c;
}
var ub = null, vb = {}, wb = [], xb = 1, yb = null, zb = !0, N = null, qb = {}, Bb = (a, b = {}) => {
  a = bb(a);
  if (!a) {
    return {path:"", node:null};
  }
  b = Object.assign({hb:!0, Wa:0}, b);
  if (8 < b.Wa) {
    throw new N(32);
  }
  a = a.split("/").filter(g => !!g);
  for (var c = ub, d = "/", e = 0; e < a.length; e++) {
    var f = e === a.length - 1;
    if (f && b.parent) {
      break;
    }
    c = rb(c, a[e]);
    d = Xa(d + "/" + a[e]);
    c.Da && (!f || f && b.hb) && (c = c.Da.root);
    if (!f || b.gb) {
      for (f = 0; 40960 === (c.mode & 61440);) {
        if (c = Ab(d), d = bb(Ya(d), c), c = Bb(d, {Wa:b.Wa + 1}).node, 40 < f++) {
          throw new N(32);
        }
      }
    }
  }
  return {path:d, node:c};
}, Cb = a => {
  for (var b;;) {
    if (a === a.parent) {
      return a = a.U.mb, b ? "/" !== a[a.length - 1] ? `${a}/${b}` : a + b : a;
    }
    b = b ? `${a.name}/${b}` : a.name;
    a = a.parent;
  }
}, Db = (a, b) => {
  for (var c = 0, d = 0; d < b.length; d++) {
    c = (c << 5) - c + b.charCodeAt(d) | 0;
  }
  return (a + c >>> 0) % yb.length;
}, rb = (a, b) => {
  var c;
  if (c = (c = Eb(a, "x")) ? c : a.l.ma ? 0 : 2) {
    throw new N(c, a);
  }
  for (c = yb[Db(a.id, b)]; c; c = c.ec) {
    var d = c.name;
    if (c.parent.id === a.id && d === b) {
      return c;
    }
  }
  return a.l.ma(a, b);
}, pb = (a, b, c, d) => {
  a = new Fb(a, b, c, d);
  b = Db(a.parent.id, a.name);
  a.ec = yb[b];
  return yb[b] = a;
}, Gb = a => {
  var b = ["r", "w", "rw"][a & 3];
  a & 512 && (b += "w");
  return b;
}, Eb = (a, b) => {
  if (zb) {
    return 0;
  }
  if (!b.includes("r") || a.mode & 292) {
    if (b.includes("w") && !(a.mode & 146) || b.includes("x") && !(a.mode & 73)) {
      return 2;
    }
  } else {
    return 2;
  }
  return 0;
}, Hb = (a, b) => {
  try {
    return rb(a, b), 20;
  } catch (c) {
  }
  return Eb(a, "wx");
}, Ib = () => {
  for (var a = 0; 4096 >= a; a++) {
    if (!wb[a]) {
      return a;
    }
  }
  throw new N(33);
}, Jb = a => {
  a = wb[a];
  if (!a) {
    throw new N(8);
  }
  return a;
}, Lb = (a, b = -1) => {
  Kb || (Kb = function() {
    this.h = {};
  }, Kb.prototype = {}, Object.defineProperties(Kb.prototype, {object:{get() {
    return this.node;
  }, set(c) {
    this.node = c;
  }}, flags:{get() {
    return this.h.flags;
  }, set(c) {
    this.h.flags = c;
  },}, position:{get() {
    return this.h.position;
  }, set(c) {
    this.h.position = c;
  },},}));
  a = Object.assign(new Kb(), a);
  -1 == b && (b = Ib());
  a.X = b;
  return wb[b] = a;
}, ob = {open:a => {
  a.m = vb[a.node.Fa].m;
  a.m.open && a.m.open(a);
}, ba:() => {
  throw new N(70);
},}, jb = (a, b) => {
  vb[a] = {m:b};
}, Mb = (a, b) => {
  var c = "/" === b, d = !b;
  if (c && ub) {
    throw new N(10);
  }
  if (!c && !d) {
    var e = Bb(b, {hb:!1});
    b = e.path;
    e = e.node;
    if (e.Da) {
      throw new N(10);
    }
    if (16384 !== (e.mode & 61440)) {
      throw new N(54);
    }
  }
  b = {type:a, Nc:{}, mb:b, dc:[]};
  a = a.U(b);
  a.U = b;
  b.root = a;
  c ? ub = a : e && (e.Da = b, e.U && e.U.dc.push(b));
}, P = (a, b, c) => {
  var d = Bb(a, {parent:!0}).node;
  a = Za(a);
  if (!a || "." === a || ".." === a) {
    throw new N(28);
  }
  var e = Hb(d, a);
  if (e) {
    throw new N(e);
  }
  if (!d.l.Ca) {
    throw new N(63);
  }
  return d.l.Ca(d, a, b, c);
}, Nb = (a, b, c) => {
  "undefined" == typeof c && (c = b, b = 438);
  P(a, b | 8192, c);
}, Ob = (a, b) => {
  if (!bb(a)) {
    throw new N(44);
  }
  var c = Bb(b, {parent:!0}).node;
  if (!c) {
    throw new N(44);
  }
  b = Za(b);
  var d = Hb(c, b);
  if (d) {
    throw new N(d);
  }
  if (!c.l.Ia) {
    throw new N(63);
  }
  c.l.Ia(c, b, a);
}, Ab = a => {
  a = Bb(a).node;
  if (!a) {
    throw new N(44);
  }
  if (!a.l.na) {
    throw new N(28);
  }
  return bb(Cb(a.parent), a.l.na(a));
}, Qb = (a, b, c) => {
  if ("" === a) {
    throw new N(44);
  }
  if ("string" == typeof b) {
    var d = {r:0, "r+":2, w:577, "w+":578, a:1089, "a+":1090,}[b];
    if ("undefined" == typeof d) {
      throw Error(`Unknown file open mode: ${b}`);
    }
    b = d;
  }
  c = b & 64 ? ("undefined" == typeof c ? 438 : c) & 4095 | 32768 : 0;
  if ("object" == typeof a) {
    var e = a;
  } else {
    a = Xa(a);
    try {
      e = Bb(a, {gb:!(b & 131072)}).node;
    } catch (f) {
    }
  }
  d = !1;
  if (b & 64) {
    if (e) {
      if (b & 128) {
        throw new N(20);
      }
    } else {
      e = P(a, c, 0), d = !0;
    }
  }
  if (!e) {
    throw new N(44);
  }
  8192 === (e.mode & 61440) && (b &= -513);
  if (b & 65536 && 16384 !== (e.mode & 61440)) {
    throw new N(54);
  }
  if (!d && (c = e ? 40960 === (e.mode & 61440) ? 32 : 16384 === (e.mode & 61440) && ("r" !== Gb(b) || b & 512) ? 31 : Eb(e, Gb(b)) : 44)) {
    throw new N(c);
  }
  if (b & 512 && !d) {
    c = e;
    c = "string" == typeof c ? Bb(c, {gb:!0}).node : c;
    if (!c.l.P) {
      throw new N(63);
    }
    if (16384 === (c.mode & 61440)) {
      throw new N(31);
    }
    if (32768 !== (c.mode & 61440)) {
      throw new N(28);
    }
    if (d = Eb(c, "w")) {
      throw new N(d);
    }
    c.l.P(c, {size:0, timestamp:Date.now()});
  }
  b &= -131713;
  e = Lb({node:e, path:Cb(e), flags:b, seekable:!0, position:0, m:e.m, sc:[], error:!1});
  e.m.open && e.m.open(e);
  !k.logReadFiles || b & 1 || (Pb || (Pb = {}), a in Pb || (Pb[a] = 1));
  return e;
}, Rb = (a, b, c) => {
  if (null === a.X) {
    throw new N(8);
  }
  if (!a.seekable || !a.m.ba) {
    throw new N(70);
  }
  if (0 != c && 1 != c && 2 != c) {
    throw new N(28);
  }
  a.position = a.m.ba(a, b, c);
  a.sc = [];
}, Sb = () => {
  N || (N = function(a, b) {
    this.name = "ErrnoError";
    this.node = b;
    this.ic = function(c) {
      this.aa = c;
    };
    this.ic(a);
    this.message = "FS error";
  }, N.prototype = Error(), N.prototype.constructor = N, [44].forEach(a => {
    qb[a] = new N(a);
    qb[a].stack = "<generic error, no stack>";
  }));
}, Tb, Vb = (a, b, c) => {
  a = Xa("/dev/" + a);
  var d = sb(!!b, !!c);
  Ub || (Ub = 64);
  var e = Ub++ << 8 | 0;
  jb(e, {open:f => {
    f.seekable = !1;
  }, close:() => {
    c && c.buffer && c.buffer.length && c(10);
  }, read:(f, g, l, p) => {
    for (var m = 0, t = 0; t < p; t++) {
      try {
        var v = b();
      } catch (x) {
        throw new N(29);
      }
      if (void 0 === v && 0 === m) {
        throw new N(6);
      }
      if (null === v || void 0 === v) {
        break;
      }
      m++;
      g[l + t] = v;
    }
    m && (f.node.timestamp = Date.now());
    return m;
  }, write:(f, g, l, p) => {
    for (var m = 0; m < p; m++) {
      try {
        c(g[l + m]);
      } catch (t) {
        throw new N(29);
      }
    }
    p && (f.node.timestamp = Date.now());
    return m;
  }});
  Nb(a, d, e);
}, Ub, Wb = {}, Kb, Pb, Xb = void 0;
function Yb() {
  Xb += 4;
  return I[Xb - 4 >> 2];
}
function Zb(a) {
  if (void 0 === a) {
    return "_unknown";
  }
  a = a.replace(/[^a-zA-Z0-9_]/g, "$");
  var b = a.charCodeAt(0);
  return 48 <= b && 57 >= b ? `_${a}` : a;
}
function $b(a, b) {
  a = Zb(a);
  return {[a]:function() {
    return b.apply(this, arguments);
  }}[a];
}
function ac() {
  this.M = [void 0];
  this.ib = [];
}
var Q = new ac(), bc = void 0;
function R(a) {
  throw new bc(a);
}
var S = a => {
  a || R("Cannot use deleted val. handle = " + a);
  return Q.get(a).value;
}, T = a => {
  switch(a) {
    case void 0:
      return 1;
    case null:
      return 2;
    case !0:
      return 3;
    case !1:
      return 4;
    default:
      return Q.ta({ub:1, value:a});
  }
};
function cc(a) {
  var b = Error, c = $b(a, function(d) {
    this.name = a;
    this.message = d;
    d = Error(d).stack;
    void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
  });
  c.prototype = Object.create(b.prototype);
  c.prototype.constructor = c;
  c.prototype.toString = function() {
    return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
  };
  return c;
}
var dc = void 0, ec = void 0;
function U(a) {
  for (var b = ""; F[a];) {
    b += ec[F[a++]];
  }
  return b;
}
var fc = [];
function gc() {
  for (; fc.length;) {
    var a = fc.pop();
    a.g.ia = !1;
    a["delete"]();
  }
}
var hc = void 0, ic = {};
function jc(a, b) {
  for (void 0 === b && R("ptr should not be undefined"); a.A;) {
    b = a.pa(b), a = a.A;
  }
  return b;
}
var kc = {};
function lc(a) {
  a = mc(a);
  var b = U(a);
  nc(a);
  return b;
}
function oc(a, b) {
  var c = kc[a];
  void 0 === c && R(b + " has unknown type " + lc(a));
  return c;
}
function pc() {
}
var qc = !1;
function rc(a) {
  --a.count.value;
  0 === a.count.value && (a.H ? a.L.W(a.H) : a.u.i.W(a.o));
}
function sc(a, b, c) {
  if (b === c) {
    return a;
  }
  if (void 0 === c.A) {
    return null;
  }
  a = sc(a, b, c.A);
  return null === a ? null : c.Mb(a);
}
var tc = {};
function uc(a, b) {
  b = jc(a, b);
  return ic[b];
}
var vc = void 0;
function wc(a) {
  throw new vc(a);
}
function xc(a, b) {
  b.u && b.o || wc("makeClassHandle requires ptr and ptrType");
  !!b.L !== !!b.H && wc("Both smartPtrType and smartPtr must be specified");
  b.count = {value:1};
  return yc(Object.create(a, {g:{value:b,},}));
}
function yc(a) {
  if ("undefined" === typeof FinalizationRegistry) {
    return yc = b => b, a;
  }
  qc = new FinalizationRegistry(b => {
    rc(b.g);
  });
  yc = b => {
    var c = b.g;
    c.H && qc.register(b, {g:c}, b);
    return b;
  };
  pc = b => {
    qc.unregister(b);
  };
  return yc(a);
}
var zc = {};
function Ac(a) {
  for (; a.length;) {
    var b = a.pop();
    a.pop()(b);
  }
}
function Bc(a) {
  return this.fromWireType(I[a >> 2]);
}
var Cc = {}, Dc = {};
function V(a, b, c) {
  function d(l) {
    l = c(l);
    l.length !== a.length && wc("Mismatched type converter count");
    for (var p = 0; p < a.length; ++p) {
      Ec(a[p], l[p]);
    }
  }
  a.forEach(function(l) {
    Dc[l] = b;
  });
  var e = Array(b.length), f = [], g = 0;
  b.forEach((l, p) => {
    kc.hasOwnProperty(l) ? e[p] = kc[l] : (f.push(l), Cc.hasOwnProperty(l) || (Cc[l] = []), Cc[l].push(() => {
      e[p] = kc[l];
      ++g;
      g === f.length && d(e);
    }));
  });
  0 === f.length && d(e);
}
function Fc(a) {
  switch(a) {
    case 1:
      return 0;
    case 2:
      return 1;
    case 4:
      return 2;
    case 8:
      return 3;
    default:
      throw new TypeError(`Unknown type size: ${a}`);
  }
}
function Gc(a, b, c = {}) {
  var d = b.name;
  a || R(`type "${d}" must have a positive integer typeid pointer`);
  if (kc.hasOwnProperty(a)) {
    if (c.Xb) {
      return;
    }
    R(`Cannot register type '${d}' twice`);
  }
  kc[a] = b;
  delete Dc[a];
  Cc.hasOwnProperty(a) && (b = Cc[a], delete Cc[a], b.forEach(e => e()));
}
function Ec(a, b, c = {}) {
  if (!("argPackAdvance" in b)) {
    throw new TypeError("registerType registeredInstance requires argPackAdvance");
  }
  Gc(a, b, c);
}
function Hc(a) {
  R(a.g.u.i.name + " instance already deleted");
}
function Ic() {
}
function Jc(a, b, c) {
  if (void 0 === a[b].B) {
    var d = a[b];
    a[b] = function() {
      a[b].B.hasOwnProperty(arguments.length) || R(`Function '${c}' called with an invalid number of arguments (${arguments.length}) - expects one of (${a[b].B})!`);
      return a[b].B[arguments.length].apply(this, arguments);
    };
    a[b].B = [];
    a[b].B[d.ha] = d;
  }
}
function Kc(a, b, c) {
  k.hasOwnProperty(a) ? ((void 0 === c || void 0 !== k[a].B && void 0 !== k[a].B[c]) && R(`Cannot register public name '${a}' twice`), Jc(k, a, a), k.hasOwnProperty(c) && R(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`), k[a].B[c] = b) : (k[a] = b, void 0 !== c && (k[a].Mc = c));
}
function Lc(a, b, c, d, e, f, g, l) {
  this.name = a;
  this.constructor = b;
  this.N = c;
  this.W = d;
  this.A = e;
  this.Rb = f;
  this.pa = g;
  this.Mb = l;
  this.qb = [];
}
function Mc(a, b, c) {
  for (; b !== c;) {
    b.pa || R(`Expected null or instance of ${c.name}, got an instance of ${b.name}`), a = b.pa(a), b = b.A;
  }
  return a;
}
function Nc(a, b) {
  if (null === b) {
    return this.Ta && R(`null is not a valid ${this.name}`), 0;
  }
  b.g || R(`Cannot pass "${Oc(b)}" as a ${this.name}`);
  b.g.o || R(`Cannot pass deleted object as a pointer of type ${this.name}`);
  return Mc(b.g.o, b.g.u.i, this.i);
}
function Pc(a, b) {
  if (null === b) {
    this.Ta && R(`null is not a valid ${this.name}`);
    if (this.ya) {
      var c = this.Va();
      null !== a && a.push(this.W, c);
      return c;
    }
    return 0;
  }
  b.g || R(`Cannot pass "${Oc(b)}" as a ${this.name}`);
  b.g.o || R(`Cannot pass deleted object as a pointer of type ${this.name}`);
  !this.xa && b.g.u.xa && R(`Cannot convert argument of type ${b.g.L ? b.g.L.name : b.g.u.name} to parameter type ${this.name}`);
  c = Mc(b.g.o, b.g.u.i, this.i);
  if (this.ya) {
    switch(void 0 === b.g.H && R("Passing raw pointer to smart pointer is illegal"), this.mc) {
      case 0:
        b.g.L === this ? c = b.g.H : R(`Cannot convert argument of type ${b.g.L ? b.g.L.name : b.g.u.name} to parameter type ${this.name}`);
        break;
      case 1:
        c = b.g.H;
        break;
      case 2:
        if (b.g.L === this) {
          c = b.g.H;
        } else {
          var d = b.clone();
          c = this.hc(c, T(function() {
            d["delete"]();
          }));
          null !== a && a.push(this.W, c);
        }
        break;
      default:
        R("Unsupporting sharing policy");
    }
  }
  return c;
}
function Qc(a, b) {
  if (null === b) {
    return this.Ta && R(`null is not a valid ${this.name}`), 0;
  }
  b.g || R(`Cannot pass "${Oc(b)}" as a ${this.name}`);
  b.g.o || R(`Cannot pass deleted object as a pointer of type ${this.name}`);
  b.g.u.xa && R(`Cannot convert argument of type ${b.g.u.name} to parameter type ${this.name}`);
  return Mc(b.g.o, b.g.u.i, this.i);
}
function Rc(a, b, c, d) {
  this.name = a;
  this.i = b;
  this.Ta = c;
  this.xa = d;
  this.ya = !1;
  this.W = this.hc = this.Va = this.sb = this.mc = this.fc = void 0;
  void 0 !== b.A ? this.toWireType = Pc : (this.toWireType = d ? Nc : Qc, this.K = null);
}
function Sc(a, b, c) {
  k.hasOwnProperty(a) || wc("Replacing nonexistant public symbol");
  void 0 !== k[a].B && void 0 !== c ? k[a].B[c] = b : (k[a] = b, k[a].ha = c);
}
var Tc = [], Uc = a => {
  var b = Tc[a];
  b || (a >= Tc.length && (Tc.length = a + 1), Tc[a] = b = Aa.get(a));
  return b;
}, Vc = (a, b) => {
  var c = [];
  return function() {
    c.length = 0;
    Object.assign(c, arguments);
    if (a.includes("j")) {
      var d = k["dynCall_" + a];
      d = c && c.length ? d.apply(null, [b].concat(c)) : d.call(null, b);
    } else {
      d = Uc(b).apply(null, c);
    }
    return d;
  };
};
function W(a, b) {
  a = U(a);
  var c = a.includes("j") ? Vc(a, b) : Uc(b);
  "function" != typeof c && R(`unknown function pointer with signature ${a}: ${b}`);
  return c;
}
var Wc = void 0;
function Xc(a, b) {
  function c(f) {
    e[f] || kc[f] || (Dc[f] ? Dc[f].forEach(c) : (d.push(f), e[f] = !0));
  }
  var d = [], e = {};
  b.forEach(c);
  throw new Wc(`${a}: ` + d.map(lc).join([", "]));
}
function Yc(a, b, c, d, e) {
  var f = b.length;
  2 > f && R("argTypes array size mismatch! Must at least get return value and 'this' types!");
  var g = null !== b[1] && null !== c, l = !1;
  for (c = 1; c < b.length; ++c) {
    if (null !== b[c] && void 0 === b[c].K) {
      l = !0;
      break;
    }
  }
  var p = "void" !== b[0].name, m = f - 2, t = Array(m), v = [], x = [];
  return function() {
    arguments.length !== m && R(`function ${a} called with ${arguments.length} arguments, expected ${m} args!`);
    x.length = 0;
    v.length = g ? 2 : 1;
    v[0] = e;
    if (g) {
      var n = b[1].toWireType(x, this);
      v[1] = n;
    }
    for (var r = 0; r < m; ++r) {
      t[r] = b[r + 2].toWireType(x, arguments[r]), v.push(t[r]);
    }
    r = d.apply(null, v);
    if (l) {
      Ac(x);
    } else {
      for (var u = g ? 1 : 2; u < b.length; u++) {
        var y = 1 === u ? n : t[u - 2];
        null !== b[u].K && b[u].K(y);
      }
    }
    n = p ? b[0].fromWireType(r) : void 0;
    return n;
  };
}
function Zc(a, b) {
  for (var c = [], d = 0; d < a; d++) {
    c.push(K[b + 4 * d >> 2]);
  }
  return c;
}
function $c(a, b, c) {
  a instanceof Object || R(`${c} with invalid "this": ${a}`);
  a instanceof b.i.constructor || R(`${c} incompatible with "this" of type ${a.constructor.name}`);
  a.g.o || R(`cannot call emscripten binding method ${c} on deleted object`);
  return Mc(a.g.o, a.g.u.i, b.i);
}
function ad(a) {
  a >= Q.h && 0 === --Q.get(a).ub && Q.Wb(a);
}
function bd(a, b, c) {
  switch(b) {
    case 0:
      return function(d) {
        return this.fromWireType((c ? D : F)[d]);
      };
    case 1:
      return function(d) {
        return this.fromWireType((c ? G : wa)[d >> 1]);
      };
    case 2:
      return function(d) {
        return this.fromWireType((c ? I : K)[d >> 2]);
      };
    default:
      throw new TypeError("Unknown integer type: " + a);
  }
}
function Oc(a) {
  if (null === a) {
    return "null";
  }
  var b = typeof a;
  return "object" === b || "array" === b || "function" === b ? a.toString() : "" + a;
}
function cd(a, b) {
  switch(b) {
    case 2:
      return function(c) {
        return this.fromWireType(xa[c >> 2]);
      };
    case 3:
      return function(c) {
        return this.fromWireType(ya[c >> 3]);
      };
    default:
      throw new TypeError("Unknown float type: " + a);
  }
}
function dd(a, b, c) {
  switch(b) {
    case 0:
      return c ? function(d) {
        return D[d];
      } : function(d) {
        return F[d];
      };
    case 1:
      return c ? function(d) {
        return G[d >> 1];
      } : function(d) {
        return wa[d >> 1];
      };
    case 2:
      return c ? function(d) {
        return I[d >> 2];
      } : function(d) {
        return K[d >> 2];
      };
    default:
      throw new TypeError("Unknown integer type: " + a);
  }
}
var ed = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, fd = (a, b) => {
  var c = a >> 1;
  for (var d = c + b / 2; !(c >= d) && wa[c];) {
    ++c;
  }
  c <<= 1;
  if (32 < c - a && ed) {
    return ed.decode(F.subarray(a, c));
  }
  c = "";
  for (d = 0; !(d >= b / 2); ++d) {
    var e = G[a + 2 * d >> 1];
    if (0 == e) {
      break;
    }
    c += String.fromCharCode(e);
  }
  return c;
}, gd = (a, b, c) => {
  void 0 === c && (c = 2147483647);
  if (2 > c) {
    return 0;
  }
  c -= 2;
  var d = b;
  c = c < 2 * a.length ? c / 2 : a.length;
  for (var e = 0; e < c; ++e) {
    G[b >> 1] = a.charCodeAt(e), b += 2;
  }
  G[b >> 1] = 0;
  return b - d;
}, hd = a => 2 * a.length, jd = (a, b) => {
  for (var c = 0, d = ""; !(c >= b / 4);) {
    var e = I[a + 4 * c >> 2];
    if (0 == e) {
      break;
    }
    ++c;
    65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
  }
  return d;
}, kd = (a, b, c) => {
  void 0 === c && (c = 2147483647);
  if (4 > c) {
    return 0;
  }
  var d = b;
  c = d + c - 4;
  for (var e = 0; e < a.length; ++e) {
    var f = a.charCodeAt(e);
    if (55296 <= f && 57343 >= f) {
      var g = a.charCodeAt(++e);
      f = 65536 + ((f & 1023) << 10) | g & 1023;
    }
    I[b >> 2] = f;
    b += 4;
    if (b + 4 > c) {
      break;
    }
  }
  I[b >> 2] = 0;
  return b - d;
}, ld = a => {
  for (var b = 0, c = 0; c < a.length; ++c) {
    var d = a.charCodeAt(c);
    55296 <= d && 57343 >= d && ++c;
    b += 4;
  }
  return b;
}, md = {};
function nd(a) {
  var b = md[a];
  return void 0 === b ? U(a) : b;
}
var od = [];
function pd(a) {
  var b = od.length;
  od.push(a);
  return b;
}
function qd(a, b) {
  for (var c = Array(a), d = 0; d < a; ++d) {
    c[d] = oc(K[b + 4 * d >> 2], "parameter " + d);
  }
  return c;
}
var rd = [], sd = [];
function td(a) {
  a.Dc = a.getExtension("WEBGL_draw_instanced_base_vertex_base_instance");
}
function ud(a) {
  a.Ic = a.getExtension("WEBGL_multi_draw_instanced_base_vertex_base_instance");
}
var vd = 1, wd = [], X = [], xd = [], yd = [], zd = [], Ad = [], Bd = [], w = [], Cd = {};
function Y(a) {
  Dd || (Dd = a);
}
function Ed(a) {
  for (var b = vd++, c = a.length; c < b; c++) {
    a[c] = null;
  }
  return b;
}
function ia(a, b) {
  var c = Ed(w), d = {handle:c, attributes:b, version:b.Hc, C:a};
  a.canvas && (a.canvas.Cb = d);
  w[c] = d;
  ("undefined" == typeof b.Nb || b.Nb) && Fd(d);
  return c;
}
function ja(a) {
  q = w[a];
  k.Bc = Z = q && q.C;
  return !(a && !Z);
}
function Fd(a) {
  a || (a = q);
  if (!a.Yb) {
    a.Yb = !0;
    var b = a.C;
    td(b);
    ud(b);
    2 <= a.version && (b.eb = b.getExtension("EXT_disjoint_timer_query_webgl2"));
    if (2 > a.version || !b.eb) {
      b.eb = b.getExtension("EXT_disjoint_timer_query");
    }
    Gd(b);
    (b.getSupportedExtensions() || []).forEach(function(c) {
      c.includes("lose_context") || c.includes("debug") || b.getExtension(c);
    });
  }
}
var Dd, q;
function Gd(a) {
  a.Kc = a.getExtension("WEBGL_multi_draw");
}
var Hd = {}, Jd = () => {
  if (!Id) {
    var a = {USER:"web_user", LOGNAME:"web_user", PATH:"/", PWD:"/", HOME:"/home/web_user", LANG:("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _:la || "./this.program"}, b;
    for (b in Hd) {
      void 0 === Hd[b] ? delete a[b] : a[b] = Hd[b];
    }
    var c = [];
    for (b in a) {
      c.push(`${b}=${a[b]}`);
    }
    Id = c;
  }
  return Id;
}, Id, Kd = [];
function Ld(a, b, c, d) {
  for (var e = 0; e < a; e++) {
    var f = Z[c](), g = f && Ed(d);
    f ? (f.name = g, d[g] = f) : Y(1282);
    I[b + 4 * e >> 2] = g;
  }
}
function Md(a, b) {
  if (b) {
    var c = void 0;
    switch(a) {
      case 36346:
        c = 1;
        break;
      case 36344:
        return;
      case 34814:
      case 36345:
        c = 0;
        break;
      case 34466:
        var d = Z.getParameter(34467);
        c = d ? d.length : 0;
        break;
      case 33309:
        if (2 > q.version) {
          Y(1282);
          return;
        }
        c = 2 * (Z.getSupportedExtensions() || []).length;
        break;
      case 33307:
      case 33308:
        if (2 > q.version) {
          Y(1280);
          return;
        }
        c = 33307 == a ? 3 : 0;
    }
    if (void 0 === c) {
      switch(d = Z.getParameter(a), typeof d) {
        case "number":
          c = d;
          break;
        case "boolean":
          c = d ? 1 : 0;
          break;
        case "string":
          Y(1280);
          return;
        case "object":
          if (null === d) {
            switch(a) {
              case 34964:
              case 35725:
              case 34965:
              case 36006:
              case 36007:
              case 32873:
              case 34229:
              case 36662:
              case 36663:
              case 35053:
              case 35055:
              case 36010:
              case 35097:
              case 35869:
              case 32874:
              case 36389:
              case 35983:
              case 35368:
              case 34068:
                c = 0;
                break;
              default:
                Y(1280);
                return;
            }
          } else {
            if (d instanceof Float32Array || d instanceof Uint32Array || d instanceof Int32Array || d instanceof Array) {
              for (a = 0; a < d.length; ++a) {
                I[b + 4 * a >> 2] = d[a];
              }
              return;
            }
            try {
              c = d.name | 0;
            } catch (e) {
              Y(1280);
              ra("GL_INVALID_ENUM in glGet0v: Unknown object returned from WebGL getParameter(" + a + ")! (error: " + e + ")");
              return;
            }
          }
          break;
        default:
          Y(1280);
          ra("GL_INVALID_ENUM in glGet0v: Native code calling glGet0v(" + a + ") and it returns " + d + " of type " + typeof d + "!");
          return;
      }
    }
    I[b >> 2] = c;
  } else {
    Y(1281);
  }
}
var Od = a => {
  var b = eb(a) + 1, c = Nd(b);
  c && fb(a, F, c, b);
  return c;
};
function Pd(a) {
  return "]" == a.slice(-1) && a.lastIndexOf("[");
}
function Qd(a) {
  a -= 5120;
  return 0 == a ? D : 1 == a ? F : 2 == a ? G : 4 == a ? I : 6 == a ? xa : 5 == a || 28922 == a || 28520 == a || 30779 == a || 30782 == a ? K : wa;
}
var Rd = a => 0 === a % 4 && (0 !== a % 100 || 0 === a % 400), Sd = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Td = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ud = (a, b, c, d) => {
  function e(n, r, u) {
    for (n = "number" == typeof n ? n.toString() : n || ""; n.length < r;) {
      n = u[0] + n;
    }
    return n;
  }
  function f(n, r) {
    return e(n, r, "0");
  }
  function g(n, r) {
    function u(z) {
      return 0 > z ? -1 : 0 < z ? 1 : 0;
    }
    var y;
    0 === (y = u(n.getFullYear() - r.getFullYear())) && 0 === (y = u(n.getMonth() - r.getMonth())) && (y = u(n.getDate() - r.getDate()));
    return y;
  }
  function l(n) {
    switch(n.getDay()) {
      case 0:
        return new Date(n.getFullYear() - 1, 11, 29);
      case 1:
        return n;
      case 2:
        return new Date(n.getFullYear(), 0, 3);
      case 3:
        return new Date(n.getFullYear(), 0, 2);
      case 4:
        return new Date(n.getFullYear(), 0, 1);
      case 5:
        return new Date(n.getFullYear() - 1, 11, 31);
      case 6:
        return new Date(n.getFullYear() - 1, 11, 30);
    }
  }
  function p(n) {
    var r = n.da;
    for (n = new Date((new Date(n.ea + 1900, 0, 1)).getTime()); 0 < r;) {
      var u = n.getMonth(), y = (Rd(n.getFullYear()) ? Sd : Td)[u];
      if (r > y - n.getDate()) {
        r -= y - n.getDate() + 1, n.setDate(1), 11 > u ? n.setMonth(u + 1) : (n.setMonth(0), n.setFullYear(n.getFullYear() + 1));
      } else {
        n.setDate(n.getDate() + r);
        break;
      }
    }
    u = new Date(n.getFullYear() + 1, 0, 4);
    r = l(new Date(n.getFullYear(), 0, 4));
    u = l(u);
    return 0 >= g(r, n) ? 0 >= g(u, n) ? n.getFullYear() + 1 : n.getFullYear() : n.getFullYear() - 1;
  }
  var m = I[d + 40 >> 2];
  d = {pc:I[d >> 2], oc:I[d + 4 >> 2], Ja:I[d + 8 >> 2], Xa:I[d + 12 >> 2], Ka:I[d + 16 >> 2], ea:I[d + 20 >> 2], R:I[d + 24 >> 2], da:I[d + 28 >> 2], Pc:I[d + 32 >> 2], nc:I[d + 36 >> 2], qc:m ? m ? M(F, m) : "" : ""};
  c = c ? M(F, c) : "";
  m = {"%c":"%a %b %d %H:%M:%S %Y", "%D":"%m/%d/%y", "%F":"%Y-%m-%d", "%h":"%b", "%r":"%I:%M:%S %p", "%R":"%H:%M", "%T":"%H:%M:%S", "%x":"%m/%d/%y", "%X":"%H:%M:%S", "%Ec":"%c", "%EC":"%C", "%Ex":"%m/%d/%y", "%EX":"%H:%M:%S", "%Ey":"%y", "%EY":"%Y", "%Od":"%d", "%Oe":"%e", "%OH":"%H", "%OI":"%I", "%Om":"%m", "%OM":"%M", "%OS":"%S", "%Ou":"%u", "%OU":"%U", "%OV":"%V", "%Ow":"%w", "%OW":"%W", "%Oy":"%y",};
  for (var t in m) {
    c = c.replace(new RegExp(t, "g"), m[t]);
  }
  var v = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), x = "January February March April May June July August September October November December".split(" ");
  m = {"%a":n => v[n.R].substring(0, 3), "%A":n => v[n.R], "%b":n => x[n.Ka].substring(0, 3), "%B":n => x[n.Ka], "%C":n => f((n.ea + 1900) / 100 | 0, 2), "%d":n => f(n.Xa, 2), "%e":n => e(n.Xa, 2, " "), "%g":n => p(n).toString().substring(2), "%G":n => p(n), "%H":n => f(n.Ja, 2), "%I":n => {
    n = n.Ja;
    0 == n ? n = 12 : 12 < n && (n -= 12);
    return f(n, 2);
  }, "%j":n => {
    for (var r = 0, u = 0; u <= n.Ka - 1; r += (Rd(n.ea + 1900) ? Sd : Td)[u++]) {
    }
    return f(n.Xa + r, 3);
  }, "%m":n => f(n.Ka + 1, 2), "%M":n => f(n.oc, 2), "%n":() => "\n", "%p":n => 0 <= n.Ja && 12 > n.Ja ? "AM" : "PM", "%S":n => f(n.pc, 2), "%t":() => "\t", "%u":n => n.R || 7, "%U":n => f(Math.floor((n.da + 7 - n.R) / 7), 2), "%V":n => {
    var r = Math.floor((n.da + 7 - (n.R + 6) % 7) / 7);
    2 >= (n.R + 371 - n.da - 2) % 7 && r++;
    if (r) {
      53 == r && (u = (n.R + 371 - n.da) % 7, 4 == u || 3 == u && Rd(n.ea) || (r = 1));
    } else {
      r = 52;
      var u = (n.R + 7 - n.da - 1) % 7;
      (4 == u || 5 == u && Rd(n.ea % 400 - 1)) && r++;
    }
    return f(r, 2);
  }, "%w":n => n.R, "%W":n => f(Math.floor((n.da + 7 - (n.R + 6) % 7) / 7), 2), "%y":n => (n.ea + 1900).toString().substring(2), "%Y":n => n.ea + 1900, "%z":n => {
    n = n.nc;
    var r = 0 <= n;
    n = Math.abs(n) / 60;
    return (r ? "+" : "-") + String("0000" + (n / 60 * 100 + n % 60)).slice(-4);
  }, "%Z":n => n.qc, "%%":() => "%"};
  c = c.replace(/%%/g, "\x00\x00");
  for (t in m) {
    c.includes(t) && (c = c.replace(new RegExp(t, "g"), m[t](d)));
  }
  c = c.replace(/\0\0/g, "%");
  t = gb(c, !1);
  if (t.length > b) {
    return 0;
  }
  D.set(t, a);
  return t.length - 1;
};
function Fb(a, b, c, d) {
  a || (a = this);
  this.parent = a;
  this.U = a.U;
  this.Da = null;
  this.id = xb++;
  this.name = b;
  this.mode = c;
  this.l = {};
  this.m = {};
  this.Fa = d;
}
Object.defineProperties(Fb.prototype, {read:{get:function() {
  return 365 === (this.mode & 365);
}, set:function(a) {
  a ? this.mode |= 365 : this.mode &= -366;
}}, write:{get:function() {
  return 146 === (this.mode & 146);
}, set:function(a) {
  a ? this.mode |= 146 : this.mode &= -147;
}}});
Sb();
yb = Array(4096);
Mb(O, "/");
P("/tmp", 16895, 0);
P("/home", 16895, 0);
P("/home/web_user", 16895, 0);
(() => {
  P("/dev", 16895, 0);
  jb(259, {read:() => 0, write:(d, e, f, g) => g,});
  Nb("/dev/null", 259);
  ib(1280, lb);
  ib(1536, mb);
  Nb("/dev/tty", 1280);
  Nb("/dev/tty1", 1536);
  var a = new Uint8Array(1024), b = 0, c = () => {
    0 === b && (b = ab(a).byteLength);
    return a[--b];
  };
  Vb("random", c);
  Vb("urandom", c);
  P("/dev/shm", 16895, 0);
  P("/dev/shm/tmp", 16895, 0);
})();
(() => {
  P("/proc", 16895, 0);
  var a = P("/proc/self", 16895, 0);
  P("/proc/self/fd", 16895, 0);
  Mb({U:() => {
    var b = pb(a, "fd", 16895, 73);
    b.l = {ma:(c, d) => {
      var e = Jb(+d);
      c = {parent:null, U:{mb:"fake"}, l:{na:() => e.path},};
      return c.parent = c;
    }};
    return b;
  }}, "/proc/self/fd");
})();
Object.assign(ac.prototype, {get(a) {
  return this.M[a];
}, has(a) {
  return void 0 !== this.M[a];
}, ta(a) {
  var b = this.ib.pop() || this.M.length;
  this.M[b] = a;
  return b;
}, Wb(a) {
  this.M[a] = void 0;
  this.ib.push(a);
}});
bc = k.BindingError = class extends Error {
  constructor(a) {
    super(a);
    this.name = "BindingError";
  }
};
Q.M.push({value:void 0}, {value:null}, {value:!0}, {value:!1},);
Q.h = Q.M.length;
k.count_emval_handles = function() {
  for (var a = 0, b = Q.h; b < Q.M.length; ++b) {
    void 0 !== Q.M[b] && ++a;
  }
  return a;
};
dc = k.PureVirtualError = cc("PureVirtualError");
for (var Vd = Array(256), Wd = 0; 256 > Wd; ++Wd) {
  Vd[Wd] = String.fromCharCode(Wd);
}
ec = Vd;
k.getInheritedInstanceCount = function() {
  return Object.keys(ic).length;
};
k.getLiveInheritedInstances = function() {
  var a = [], b;
  for (b in ic) {
    ic.hasOwnProperty(b) && a.push(ic[b]);
  }
  return a;
};
k.flushPendingDeletes = gc;
k.setDelayFunction = function(a) {
  hc = a;
  fc.length && hc && hc(gc);
};
vc = k.InternalError = class extends Error {
  constructor(a) {
    super(a);
    this.name = "InternalError";
  }
};
Ic.prototype.isAliasOf = function(a) {
  if (!(this instanceof Ic && a instanceof Ic)) {
    return !1;
  }
  var b = this.g.u.i, c = this.g.o, d = a.g.u.i;
  for (a = a.g.o; b.A;) {
    c = b.pa(c), b = b.A;
  }
  for (; d.A;) {
    a = d.pa(a), d = d.A;
  }
  return b === d && c === a;
};
Ic.prototype.clone = function() {
  this.g.o || Hc(this);
  if (this.g.ka) {
    return this.g.count.value += 1, this;
  }
  var a = yc, b = Object, c = b.create, d = Object.getPrototypeOf(this), e = this.g;
  a = a(c.call(b, d, {g:{value:{count:e.count, ia:e.ia, ka:e.ka, o:e.o, u:e.u, H:e.H, L:e.L,},}}));
  a.g.count.value += 1;
  a.g.ia = !1;
  return a;
};
Ic.prototype["delete"] = function() {
  this.g.o || Hc(this);
  this.g.ia && !this.g.ka && R("Object already scheduled for deletion");
  pc(this);
  rc(this.g);
  this.g.ka || (this.g.H = void 0, this.g.o = void 0);
};
Ic.prototype.isDeleted = function() {
  return !this.g.o;
};
Ic.prototype.deleteLater = function() {
  this.g.o || Hc(this);
  this.g.ia && !this.g.ka && R("Object already scheduled for deletion");
  fc.push(this);
  1 === fc.length && hc && hc(gc);
  this.g.ia = !0;
  return this;
};
Rc.prototype.Sb = function(a) {
  this.sb && (a = this.sb(a));
  return a;
};
Rc.prototype.cb = function(a) {
  this.W && this.W(a);
};
Rc.prototype.argPackAdvance = 8;
Rc.prototype.readValueFromPointer = Bc;
Rc.prototype.deleteObject = function(a) {
  if (null !== a) {
    a["delete"]();
  }
};
Rc.prototype.fromWireType = function(a) {
  function b() {
    return this.ya ? xc(this.i.N, {u:this.fc, o:c, L:this, H:a,}) : xc(this.i.N, {u:this, o:a,});
  }
  var c = this.Sb(a);
  if (!c) {
    return this.cb(a), null;
  }
  var d = uc(this.i, c);
  if (void 0 !== d) {
    if (0 === d.g.count.value) {
      return d.g.o = c, d.g.H = a, d.clone();
    }
    d = d.clone();
    this.cb(a);
    return d;
  }
  d = this.i.Rb(c);
  d = tc[d];
  if (!d) {
    return b.call(this);
  }
  d = this.xa ? d.Jb : d.pointerType;
  var e = sc(c, this.i, d.i);
  return null === e ? b.call(this) : this.ya ? xc(d.i.N, {u:d, o:e, L:this, H:a,}) : xc(d.i.N, {u:d, o:e,});
};
Wc = k.UnboundTypeError = cc("UnboundTypeError");
for (var Z, Xd = 0; 32 > Xd; ++Xd) {
  Kd.push(Array(Xd));
}
var Zd = {__syscall_fcntl64:function(a, b, c) {
  Xb = c;
  try {
    var d = Jb(a);
    switch(b) {
      case 0:
        var e = Yb();
        return 0 > e ? -28 : Lb(d, e).X;
      case 1:
      case 2:
        return 0;
      case 3:
        return d.flags;
      case 4:
        return e = Yb(), d.flags |= e, 0;
      case 5:
        return e = Yb(), G[e + 0 >> 1] = 2, 0;
      case 6:
      case 7:
        return 0;
      case 16:
      case 8:
        return -28;
      case 9:
        return I[Yd() >> 2] = 28, -1;
      default:
        return -28;
    }
  } catch (f) {
    if ("undefined" == typeof Wb || "ErrnoError" !== f.name) {
      throw f;
    }
    return -f.aa;
  }
}, __syscall_ioctl:function(a, b, c) {
  Xb = c;
  try {
    var d = Jb(a);
    switch(b) {
      case 21509:
        return d.s ? 0 : -59;
      case 21505:
        if (!d.s) {
          return -59;
        }
        if (d.s.V.$b) {
          b = [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,];
          var e = Yb();
          I[e >> 2] = 25856;
          I[e + 4 >> 2] = 5;
          I[e + 8 >> 2] = 191;
          I[e + 12 >> 2] = 35387;
          for (var f = 0; 32 > f; f++) {
            D[e + f + 17 >> 0] = b[f] || 0;
          }
        }
        return 0;
      case 21510:
      case 21511:
      case 21512:
        return d.s ? 0 : -59;
      case 21506:
      case 21507:
      case 21508:
        if (!d.s) {
          return -59;
        }
        if (d.s.V.ac) {
          for (e = Yb(), b = [], f = 0; 32 > f; f++) {
            b.push(D[e + f + 17 >> 0]);
          }
        }
        return 0;
      case 21519:
        if (!d.s) {
          return -59;
        }
        e = Yb();
        return I[e >> 2] = 0;
      case 21520:
        return d.s ? -28 : -59;
      case 21531:
        e = Yb();
        if (!d.m.Zb) {
          throw new N(59);
        }
        return d.m.Zb(d, b, e);
      case 21523:
        if (!d.s) {
          return -59;
        }
        d.s.V.bc && (f = [24, 80], e = Yb(), G[e >> 1] = f[0], G[e + 2 >> 1] = f[1]);
        return 0;
      case 21524:
        return d.s ? 0 : -59;
      case 21515:
        return d.s ? 0 : -59;
      default:
        return -28;
    }
  } catch (g) {
    if ("undefined" == typeof Wb || "ErrnoError" !== g.name) {
      throw g;
    }
    return -g.aa;
  }
}, __syscall_openat:function(a, b, c, d) {
  Xb = d;
  try {
    b = b ? M(F, b) : "";
    var e = b;
    if ("/" === e.charAt(0)) {
      b = e;
    } else {
      var f = -100 === a ? "/" : Jb(a).path;
      if (0 == e.length) {
        throw new N(44);
      }
      b = Xa(f + "/" + e);
    }
    var g = d ? Yb() : 0;
    return Qb(b, c, g).X;
  } catch (l) {
    if ("undefined" == typeof Wb || "ErrnoError" !== l.name) {
      throw l;
    }
    return -l.aa;
  }
}, _embind_create_inheriting_constructor:function(a, b, c) {
  a = U(a);
  b = oc(b, "wrapper");
  c = S(c);
  var d = [].slice, e = b.i, f = e.N, g = e.A.N, l = e.A.constructor;
  a = $b(a, function() {
    e.A.qb.forEach(function(m) {
      if (this[m] === g[m]) {
        throw new dc(`Pure virtual function ${m} must be implemented in JavaScript`);
      }
    }.bind(this));
    Object.defineProperty(this, "__parent", {value:f});
    this.__construct.apply(this, d.call(arguments));
  });
  f.__construct = function() {
    this === f && R("Pass correct 'this' to __construct");
    var m = l.implement.apply(void 0, [this].concat(d.call(arguments)));
    pc(m);
    var t = m.g;
    m.notifyOnDestruction();
    t.ka = !0;
    Object.defineProperties(this, {g:{value:t}});
    yc(this);
    m = t.o;
    m = jc(e, m);
    ic.hasOwnProperty(m) ? R(`Tried to register registered instance: ${m}`) : ic[m] = this;
  };
  f.__destruct = function() {
    this === f && R("Pass correct 'this' to __destruct");
    pc(this);
    var m = this.g.o;
    m = jc(e, m);
    ic.hasOwnProperty(m) ? delete ic[m] : R(`Tried to unregister unregistered instance: ${m}`);
  };
  a.prototype = Object.create(f);
  for (var p in c) {
    a.prototype[p] = c[p];
  }
  return T(a);
}, _embind_finalize_value_object:function(a) {
  var b = zc[a];
  delete zc[a];
  var c = b.Va, d = b.W, e = b.fb, f = e.map(g => g.Vb).concat(e.map(g => g.kc));
  V([a], f, g => {
    var l = {};
    e.forEach((p, m) => {
      var t = g[m], v = p.Tb, x = p.Ub, n = g[m + e.length], r = p.jc, u = p.lc;
      l[p.Pb] = {read:y => t.fromWireType(v(x, y)), write:(y, z) => {
        var B = [];
        r(u, y, n.toWireType(B, z));
        Ac(B);
      }};
    });
    return [{name:b.name, fromWireType:function(p) {
      var m = {}, t;
      for (t in l) {
        m[t] = l[t].read(p);
      }
      d(p);
      return m;
    }, toWireType:function(p, m) {
      for (var t in l) {
        if (!(t in m)) {
          throw new TypeError(`Missing field: "${t}"`);
        }
      }
      var v = c();
      for (t in l) {
        l[t].write(v, m[t]);
      }
      null !== p && p.push(d, v);
      return v;
    }, argPackAdvance:8, readValueFromPointer:Bc, K:d,}];
  });
}, _embind_register_bigint:function() {
}, _embind_register_bool:function(a, b, c, d, e) {
  var f = Fc(c);
  b = U(b);
  Ec(a, {name:b, fromWireType:function(g) {
    return !!g;
  }, toWireType:function(g, l) {
    return l ? d : e;
  }, argPackAdvance:8, readValueFromPointer:function(g) {
    if (1 === c) {
      var l = D;
    } else if (2 === c) {
      l = G;
    } else if (4 === c) {
      l = I;
    } else {
      throw new TypeError("Unknown boolean type size: " + b);
    }
    return this.fromWireType(l[g >> f]);
  }, K:null,});
}, _embind_register_class:function(a, b, c, d, e, f, g, l, p, m, t, v, x) {
  t = U(t);
  f = W(e, f);
  l && (l = W(g, l));
  m && (m = W(p, m));
  x = W(v, x);
  var n = Zb(t);
  Kc(n, function() {
    Xc(`Cannot construct ${t} due to unbound types`, [d]);
  });
  V([a, b, c], d ? [d] : [], function(r) {
    r = r[0];
    if (d) {
      var u = r.i;
      var y = u.N;
    } else {
      y = Ic.prototype;
    }
    r = $b(n, function() {
      if (Object.getPrototypeOf(this) !== z) {
        throw new bc("Use 'new' to construct " + t);
      }
      if (void 0 === B.$) {
        throw new bc(t + " has no accessible constructor");
      }
      var J = B.$[arguments.length];
      if (void 0 === J) {
        throw new bc(`Tried to invoke ctor of ${t} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(B.$).toString()}) parameters instead!`);
      }
      return J.apply(this, arguments);
    });
    var z = Object.create(y, {constructor:{value:r},});
    r.prototype = z;
    var B = new Lc(t, r, z, x, u, f, l, m);
    B.A && (void 0 === B.A.qa && (B.A.qa = []), B.A.qa.push(B));
    u = new Rc(t, B, !0, !1);
    y = new Rc(t + "*", B, !1, !1);
    var H = new Rc(t + " const*", B, !1, !0);
    tc[a] = {pointerType:y, Jb:H};
    Sc(n, r);
    return [u, y, H];
  });
}, _embind_register_class_class_function:function(a, b, c, d, e, f, g) {
  var l = Zc(c, d);
  b = U(b);
  f = W(e, f);
  V([], [a], function(p) {
    function m() {
      Xc(`Cannot call ${t} due to unbound types`, l);
    }
    p = p[0];
    var t = `${p.name}.${b}`;
    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
    var v = p.i.constructor;
    void 0 === v[b] ? (m.ha = c - 1, v[b] = m) : (Jc(v, b, t), v[b].B[c - 1] = m);
    V([], l, function(x) {
      x = Yc(t, [x[0], null].concat(x.slice(1)), null, f, g);
      void 0 === v[b].B ? (x.ha = c - 1, v[b] = x) : v[b].B[c - 1] = x;
      if (p.i.qa) {
        for (const n of p.i.qa) {
          n.constructor.hasOwnProperty(b) || (n.constructor[b] = x);
        }
      }
      return [];
    });
    return [];
  });
}, _embind_register_class_class_property:function(a, b, c, d, e, f, g, l) {
  b = U(b);
  f = W(e, f);
  V([], [a], function(p) {
    p = p[0];
    var m = `${p.name}.${b}`, t = {get() {
      Xc(`Cannot access ${m} due to unbound types`, [c]);
    }, enumerable:!0, configurable:!0};
    t.set = l ? () => {
      Xc(`Cannot access ${m} due to unbound types`, [c]);
    } : () => {
      R(`${m} is a read-only property`);
    };
    Object.defineProperty(p.i.constructor, b, t);
    V([], [c], function(v) {
      v = v[0];
      var x = {get() {
        return v.fromWireType(f(d));
      }, enumerable:!0};
      l && (l = W(g, l), x.set = n => {
        var r = [];
        l(d, v.toWireType(r, n));
        Ac(r);
      });
      Object.defineProperty(p.i.constructor, b, x);
      return [];
    });
    return [];
  });
}, _embind_register_class_constructor:function(a, b, c, d, e, f) {
  var g = Zc(b, c);
  e = W(d, e);
  V([], [a], function(l) {
    l = l[0];
    var p = `constructor ${l.name}`;
    void 0 === l.i.$ && (l.i.$ = []);
    if (void 0 !== l.i.$[b - 1]) {
      throw new bc(`Cannot register multiple constructors with identical number of parameters (${b - 1}) for class '${l.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
    }
    l.i.$[b - 1] = () => {
      Xc(`Cannot construct ${l.name} due to unbound types`, g);
    };
    V([], g, function(m) {
      m.splice(1, 0, null);
      l.i.$[b - 1] = Yc(p, m, null, e, f);
      return [];
    });
    return [];
  });
}, _embind_register_class_function:function(a, b, c, d, e, f, g, l) {
  var p = Zc(c, d);
  b = U(b);
  f = W(e, f);
  V([], [a], function(m) {
    function t() {
      Xc(`Cannot call ${v} due to unbound types`, p);
    }
    m = m[0];
    var v = `${m.name}.${b}`;
    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
    l && m.i.qb.push(b);
    var x = m.i.N, n = x[b];
    void 0 === n || void 0 === n.B && n.className !== m.name && n.ha === c - 2 ? (t.ha = c - 2, t.className = m.name, x[b] = t) : (Jc(x, b, v), x[b].B[c - 2] = t);
    V([], p, function(r) {
      r = Yc(v, r, m, f, g);
      void 0 === x[b].B ? (r.ha = c - 2, x[b] = r) : x[b].B[c - 2] = r;
      return [];
    });
    return [];
  });
}, _embind_register_class_property:function(a, b, c, d, e, f, g, l, p, m) {
  b = U(b);
  e = W(d, e);
  V([], [a], function(t) {
    t = t[0];
    var v = `${t.name}.${b}`, x = {get() {
      Xc(`Cannot access ${v} due to unbound types`, [c, g]);
    }, enumerable:!0, configurable:!0};
    x.set = p ? () => {
      Xc(`Cannot access ${v} due to unbound types`, [c, g]);
    } : () => {
      R(v + " is a read-only property");
    };
    Object.defineProperty(t.i.N, b, x);
    V([], p ? [c, g] : [c], function(n) {
      var r = n[0], u = {get() {
        var z = $c(this, t, v + " getter");
        return r.fromWireType(e(f, z));
      }, enumerable:!0};
      if (p) {
        p = W(l, p);
        var y = n[1];
        u.set = function(z) {
          var B = $c(this, t, v + " setter"), H = [];
          p(m, B, y.toWireType(H, z));
          Ac(H);
        };
      }
      Object.defineProperty(t.i.N, b, u);
      return [];
    });
    return [];
  });
}, _embind_register_emval:function(a, b) {
  b = U(b);
  Ec(a, {name:b, fromWireType:function(c) {
    var d = S(c);
    ad(c);
    return d;
  }, toWireType:function(c, d) {
    return T(d);
  }, argPackAdvance:8, readValueFromPointer:Bc, K:null,});
}, _embind_register_enum:function(a, b, c, d) {
  function e() {
  }
  c = Fc(c);
  b = U(b);
  e.values = {};
  Ec(a, {name:b, constructor:e, fromWireType:function(f) {
    return this.constructor.values[f];
  }, toWireType:function(f, g) {
    return g.value;
  }, argPackAdvance:8, readValueFromPointer:bd(b, c, d), K:null,});
  Kc(b, e);
}, _embind_register_enum_value:function(a, b, c) {
  var d = oc(a, "enum");
  b = U(b);
  a = d.constructor;
  d = Object.create(d.constructor.prototype, {value:{value:c}, constructor:{value:$b(`${d.name}_${b}`, function() {
  })},});
  a.values[c] = d;
  a[b] = d;
}, _embind_register_float:function(a, b, c) {
  c = Fc(c);
  b = U(b);
  Ec(a, {name:b, fromWireType:function(d) {
    return d;
  }, toWireType:function(d, e) {
    return e;
  }, argPackAdvance:8, readValueFromPointer:cd(b, c), K:null,});
}, _embind_register_function:function(a, b, c, d, e, f) {
  var g = Zc(b, c);
  a = U(a);
  e = W(d, e);
  Kc(a, function() {
    Xc(`Cannot call ${a} due to unbound types`, g);
  }, b - 1);
  V([], g, function(l) {
    Sc(a, Yc(a, [l[0], null].concat(l.slice(1)), null, e, f), b - 1);
    return [];
  });
}, _embind_register_integer:function(a, b, c, d, e) {
  b = U(b);
  -1 === e && (e = 4294967295);
  e = Fc(c);
  var f = l => l;
  if (0 === d) {
    var g = 32 - 8 * c;
    f = l => l << g >>> g;
  }
  c = b.includes("unsigned") ? function(l, p) {
    return p >>> 0;
  } : function(l, p) {
    return p;
  };
  Ec(a, {name:b, fromWireType:f, toWireType:c, argPackAdvance:8, readValueFromPointer:dd(b, e, 0 !== d), K:null,});
}, _embind_register_memory_view:function(a, b, c) {
  function d(f) {
    f >>= 2;
    var g = K;
    return new e(g.buffer, g[f + 1], g[f]);
  }
  var e = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array,][b];
  c = U(c);
  Ec(a, {name:c, fromWireType:d, argPackAdvance:8, readValueFromPointer:d,}, {Xb:!0,});
}, _embind_register_std_string:function(a, b) {
  b = U(b);
  var c = "std::string" === b;
  Ec(a, {name:b, fromWireType:function(d) {
    var e = K[d >> 2], f = d + 4;
    if (c) {
      for (var g = f, l = 0; l <= e; ++l) {
        var p = f + l;
        if (l == e || 0 == F[p]) {
          g = g ? M(F, g, p - g) : "";
          if (void 0 === m) {
            var m = g;
          } else {
            m += String.fromCharCode(0), m += g;
          }
          g = p + 1;
        }
      }
    } else {
      m = Array(e);
      for (l = 0; l < e; ++l) {
        m[l] = String.fromCharCode(F[f + l]);
      }
      m = m.join("");
    }
    nc(d);
    return m;
  }, toWireType:function(d, e) {
    e instanceof ArrayBuffer && (e = new Uint8Array(e));
    var f = "string" == typeof e;
    f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array || R("Cannot pass non-string to std::string");
    var g = c && f ? eb(e) : e.length;
    var l = Nd(4 + g + 1), p = l + 4;
    K[l >> 2] = g;
    if (c && f) {
      fb(e, F, p, g + 1);
    } else {
      if (f) {
        for (f = 0; f < g; ++f) {
          var m = e.charCodeAt(f);
          255 < m && (nc(p), R("String has UTF-16 code units that do not fit in 8 bits"));
          F[p + f] = m;
        }
      } else {
        for (f = 0; f < g; ++f) {
          F[p + f] = e[f];
        }
      }
    }
    null !== d && d.push(nc, l);
    return l;
  }, argPackAdvance:8, readValueFromPointer:Bc, K:function(d) {
    nc(d);
  },});
}, _embind_register_std_wstring:function(a, b, c) {
  c = U(c);
  if (2 === b) {
    var d = fd;
    var e = gd;
    var f = hd;
    var g = () => wa;
    var l = 1;
  } else {
    4 === b && (d = jd, e = kd, f = ld, g = () => K, l = 2);
  }
  Ec(a, {name:c, fromWireType:function(p) {
    for (var m = K[p >> 2], t = g(), v, x = p + 4, n = 0; n <= m; ++n) {
      var r = p + 4 + n * b;
      if (n == m || 0 == t[r >> l]) {
        x = d(x, r - x), void 0 === v ? v = x : (v += String.fromCharCode(0), v += x), x = r + b;
      }
    }
    nc(p);
    return v;
  }, toWireType:function(p, m) {
    "string" != typeof m && R(`Cannot pass non-string to C++ string type ${c}`);
    var t = f(m), v = Nd(4 + t + b);
    K[v >> 2] = t >> l;
    e(m, v + 4, t + b);
    null !== p && p.push(nc, v);
    return v;
  }, argPackAdvance:8, readValueFromPointer:Bc, K:function(p) {
    nc(p);
  },});
}, _embind_register_value_object:function(a, b, c, d, e, f) {
  zc[a] = {name:U(b), Va:W(c, d), W:W(e, f), fb:[],};
}, _embind_register_value_object_field:function(a, b, c, d, e, f, g, l, p, m) {
  zc[a].fb.push({Pb:U(b), Vb:c, Tb:W(d, e), Ub:f, kc:g, jc:W(l, p), lc:m,});
}, _embind_register_void:function(a, b) {
  b = U(b);
  Ec(a, {cc:!0, name:b, argPackAdvance:0, fromWireType:function() {
  }, toWireType:function() {
  },});
}, _emscripten_get_now_is_monotonic:() => !0, _emval_as:function(a, b, c) {
  a = S(a);
  b = oc(b, "emval::as");
  var d = [], e = T(d);
  K[c >> 2] = e;
  return b.toWireType(d, a);
}, _emval_call_method:function(a, b, c, d, e) {
  a = od[a];
  b = S(b);
  c = nd(c);
  var f = [];
  K[d >> 2] = T(f);
  return a(b, c, f, e);
}, _emval_call_void_method:function(a, b, c, d) {
  a = od[a];
  b = S(b);
  c = nd(c);
  a(b, c, null, d);
}, _emval_decref:ad, _emval_get_method_caller:function(a, b) {
  var c = qd(a, b), d = c[0];
  b = d.name + "_$" + c.slice(1).map(function(g) {
    return g.name;
  }).join("_") + "$";
  var e = rd[b];
  if (void 0 !== e) {
    return e;
  }
  var f = Array(a - 1);
  e = pd((g, l, p, m) => {
    for (var t = 0, v = 0; v < a - 1; ++v) {
      f[v] = c[v + 1].readValueFromPointer(m + t), t += c[v + 1].argPackAdvance;
    }
    g = g[l].apply(g, f);
    for (v = 0; v < a - 1; ++v) {
      c[v + 1].Lb && c[v + 1].Lb(f[v]);
    }
    if (!d.cc) {
      return d.toWireType(p, g);
    }
  });
  return rd[b] = e;
}, _emval_get_property:function(a, b) {
  a = S(a);
  b = S(b);
  return T(a[b]);
}, _emval_incref:function(a) {
  4 < a && (Q.get(a).ub += 1);
}, _emval_new_array:function() {
  return T([]);
}, _emval_new_cstring:function(a) {
  return T(nd(a));
}, _emval_new_object:function() {
  return T({});
}, _emval_run_destructors:function(a) {
  var b = S(a);
  Ac(b);
  ad(a);
}, _emval_set_property:function(a, b, c) {
  a = S(a);
  b = S(b);
  c = S(c);
  a[b] = c;
}, _emval_take_value:function(a, b) {
  a = oc(a, "_emval_take_value");
  a = a.readValueFromPointer(b);
  return T(a);
}, abort:() => {
  ta("");
}, beginPixelLocalStorageWEBGL:function(a, b, c) {
  (a = w[a].C.ca) && a.beginPixelLocalStorageWEBGL(k.HEAPU32.subarray(c, c + b));
}, decode_image:function(a, b, c) {
  var d = k.images;
  d || (d = new Map(), k.images = d);
  var e = new Image();
  d.set(a, e);
  b = k.HEAP8.subarray(b, b + c);
  c = new Uint8Array(c);
  c.set(b);
  e.src = URL.createObjectURL(new Blob([c], {type:"image/png"}));
  e.onload = function() {
    k._setWebImage(a, e.width, e.height);
  };
}, delete_image:function(a) {
  var b = k.images;
  b && b.get(a) && b.delete(a);
}, emscripten_asm_const_int:(a, b, c) => {
  sd.length = 0;
  var d;
  for (c >>= 2; d = F[b++];) {
    c += 105 != d & c, sd.push(105 == d ? I[c] : ya[c++ >> 1]), ++c;
  }
  return Ua[a].apply(null, sd);
}, emscripten_date_now:function() {
  return Date.now();
}, emscripten_get_now:() => performance.now(), emscripten_memcpy_big:(a, b, c) => F.copyWithin(a, b, b + c), emscripten_resize_heap:a => {
  var b = F.length;
  a >>>= 0;
  if (2147483648 < a) {
    return !1;
  }
  for (var c = 1; 4 >= c; c *= 2) {
    var d = b * (1 + 0.2 / c);
    d = Math.min(d, a + 100663296);
    var e = Math;
    d = Math.max(a, d);
    a: {
      e = e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - ua.buffer.byteLength + 65535 >>> 16;
      try {
        ua.grow(e);
        za();
        var f = 1;
        break a;
      } catch (g) {
      }
      f = void 0;
    }
    if (f) {
      return !0;
    }
  }
  return !1;
}, emscripten_webgl_enable_extension:function(a, b) {
  a = w[a];
  b = b ? M(F, b) : "";
  b.startsWith("GL_") && (b = b.substr(3));
  "WEBGL_draw_instanced_base_vertex_base_instance" == b && td(Z);
  "WEBGL_multi_draw_instanced_base_vertex_base_instance" == b && ud(Z);
  "WEBGL_multi_draw" == b && Gd(Z);
  return !!a.C.getExtension(b);
}, emscripten_webgl_get_current_context:function() {
  return q ? q.handle : 0;
}, emscripten_webgl_make_context_current:function(a) {
  return ja(a) ? 0 : -5;
}, enable_WEBGL_provoking_vertex:function(a) {
  a = w[a].C;
  a.rb = a.getExtension("WEBGL_provoking_vertex");
  return !!a.rb;
}, enable_WEBGL_shader_pixel_local_storage_coherent:function(a) {
  a = w[a].C;
  a.ca = a.getExtension("WEBGL_shader_pixel_local_storage");
  return !(!a.ca || !a.ca.isCoherent());
}, endPixelLocalStorageWEBGL:function(a, b, c) {
  (a = w[a].C.ca) && a.endPixelLocalStorageWEBGL(k.HEAPU32.subarray(c, c + b));
}, environ_get:(a, b) => {
  var c = 0;
  Jd().forEach(function(d, e) {
    var f = b + c;
    e = K[a + 4 * e >> 2] = f;
    for (f = 0; f < d.length; ++f) {
      D[e++ >> 0] = d.charCodeAt(f);
    }
    D[e >> 0] = 0;
    c += d.length + 1;
  });
  return 0;
}, environ_sizes_get:(a, b) => {
  var c = Jd();
  K[a >> 2] = c.length;
  var d = 0;
  c.forEach(function(e) {
    d += e.length + 1;
  });
  K[b >> 2] = d;
  return 0;
}, fd_close:function(a) {
  try {
    var b = Jb(a);
    if (null === b.X) {
      throw new N(8);
    }
    b.Sa && (b.Sa = null);
    try {
      b.m.close && b.m.close(b);
    } catch (c) {
      throw c;
    } finally {
      wb[b.X] = null;
    }
    b.X = null;
    return 0;
  } catch (c) {
    if ("undefined" == typeof Wb || "ErrnoError" !== c.name) {
      throw c;
    }
    return c.aa;
  }
}, fd_read:function(a, b, c, d) {
  try {
    a: {
      var e = Jb(a);
      a = b;
      for (var f, g = b = 0; g < c; g++) {
        var l = K[a >> 2], p = K[a + 4 >> 2];
        a += 8;
        var m = e, t = l, v = p, x = f, n = D;
        if (0 > v || 0 > x) {
          throw new N(28);
        }
        if (null === m.X) {
          throw new N(8);
        }
        if (1 === (m.flags & 2097155)) {
          throw new N(8);
        }
        if (16384 === (m.node.mode & 61440)) {
          throw new N(31);
        }
        if (!m.m.read) {
          throw new N(28);
        }
        var r = "undefined" != typeof x;
        if (!r) {
          x = m.position;
        } else if (!m.seekable) {
          throw new N(70);
        }
        var u = m.m.read(m, n, t, v, x);
        r || (m.position += u);
        var y = u;
        if (0 > y) {
          var z = -1;
          break a;
        }
        b += y;
        if (y < p) {
          break;
        }
        "undefined" !== typeof f && (f += y);
      }
      z = b;
    }
    K[d >> 2] = z;
    return 0;
  } catch (B) {
    if ("undefined" == typeof Wb || "ErrnoError" !== B.name) {
      throw B;
    }
    return B.aa;
  }
}, fd_seek:function(a, b, c, d, e) {
  b = c + 2097152 >>> 0 < 4194305 - !!b ? (b >>> 0) + 4294967296 * c : NaN;
  try {
    if (isNaN(b)) {
      return 61;
    }
    var f = Jb(a);
    Rb(f, b, d);
    Qa = [f.position >>> 0, (Pa = f.position, 1.0 <= +Math.abs(Pa) ? 0.0 < Pa ? +Math.floor(Pa / 4294967296.0) >>> 0 : ~~+Math.ceil((Pa - +(~~Pa >>> 0)) / 4294967296.0) >>> 0 : 0)];
    I[e >> 2] = Qa[0];
    I[e + 4 >> 2] = Qa[1];
    f.Sa && 0 === b && 0 === d && (f.Sa = null);
    return 0;
  } catch (g) {
    if ("undefined" == typeof Wb || "ErrnoError" !== g.name) {
      throw g;
    }
    return g.aa;
  }
}, fd_write:function(a, b, c, d) {
  try {
    a: {
      var e = Jb(a);
      a = b;
      for (var f, g = b = 0; g < c; g++) {
        var l = K[a >> 2], p = K[a + 4 >> 2];
        a += 8;
        var m = e, t = l, v = p, x = f, n = D;
        if (0 > v || 0 > x) {
          throw new N(28);
        }
        if (null === m.X) {
          throw new N(8);
        }
        if (0 === (m.flags & 2097155)) {
          throw new N(8);
        }
        if (16384 === (m.node.mode & 61440)) {
          throw new N(31);
        }
        if (!m.m.write) {
          throw new N(28);
        }
        m.seekable && m.flags & 1024 && Rb(m, 0, 2);
        var r = "undefined" != typeof x;
        if (!r) {
          x = m.position;
        } else if (!m.seekable) {
          throw new N(70);
        }
        var u = m.m.write(m, n, t, v, x, void 0);
        r || (m.position += u);
        var y = u;
        if (0 > y) {
          var z = -1;
          break a;
        }
        b += y;
        "undefined" !== typeof f && (f += y);
      }
      z = b;
    }
    K[d >> 2] = z;
    return 0;
  } catch (B) {
    if ("undefined" == typeof Wb || "ErrnoError" !== B.name) {
      throw B;
    }
    return B.aa;
  }
}, framebufferPixelLocalClearValuefvWEBGL:function(a, b, c, d, e, f) {
  (a = w[a].C.ca) && a.framebufferPixelLocalClearValuefvWEBGL(b, [c, d, e, f]);
}, framebufferTexturePixelLocalStorageWEBGL:function(a, b, c, d, e) {
  (a = w[a].C.ca) && a.framebufferTexturePixelLocalStorageWEBGL(b, zd[c], d, e);
}, getFramebufferPixelLocalStorageParameterivWEBGL:function(a, b, c) {
  return (a = w[a].C.ca) ? a.getFramebufferPixelLocalStorageParameterWEBGL(b, c) : 0;
}, glActiveTexture:function(a) {
  Z.activeTexture(a);
}, glAttachShader:function(a, b) {
  Z.attachShader(X[a], Ad[b]);
}, glBindBuffer:function(a, b) {
  35051 == a ? Z.Pa = b : 35052 == a && (Z.Qa = b);
  Z.bindBuffer(a, wd[b]);
}, glBindBufferRange:function(a, b, c, d, e) {
  Z.bindBufferRange(a, b, wd[c], d, e);
}, glBindFramebuffer:function(a, b) {
  Z.bindFramebuffer(a, xd[b]);
}, glBindRenderbuffer:function(a, b) {
  Z.bindRenderbuffer(a, yd[b]);
}, glBindTexture:function(a, b) {
  Z.bindTexture(a, zd[b]);
}, glBindVertexArray:function(a) {
  Z.bindVertexArray(Bd[a]);
}, glBlendEquation:function(a) {
  Z.blendEquation(a);
}, glBlendFunc:function(a, b) {
  Z.blendFunc(a, b);
}, glBlitFramebuffer:function(a, b, c, d, e, f, g, l, p, m) {
  Z.blitFramebuffer(a, b, c, d, e, f, g, l, p, m);
}, glBufferData:function(a, b, c, d) {
  c && b ? Z.bufferData(a, F, d, c, b) : Z.bufferData(a, b, d);
}, glBufferSubData:function(a, b, c, d) {
  c && Z.bufferSubData(a, b, F, d, c);
}, glClear:function(a) {
  Z.clear(a);
}, glClearBufferfv:function(a, b, c) {
  Z.clearBufferfv(a, b, xa, c >> 2);
}, glClearBufferuiv:function(a, b, c) {
  Z.clearBufferuiv(a, b, K, c >> 2);
}, glClearColor:function(a, b, c, d) {
  Z.clearColor(a, b, c, d);
}, glClearDepthf:function(a) {
  Z.clearDepth(a);
}, glClearStencil:function(a) {
  Z.clearStencil(a);
}, glColorMask:function(a, b, c, d) {
  Z.colorMask(!!a, !!b, !!c, !!d);
}, glCompileShader:function(a) {
  Z.compileShader(Ad[a]);
}, glCreateProgram:function() {
  var a = Ed(X), b = Z.createProgram();
  b.name = a;
  b.Ba = b.za = b.Aa = 0;
  b.Ya = 1;
  X[a] = b;
  return a;
}, glCreateShader:function(a) {
  var b = Ed(Ad);
  Ad[b] = Z.createShader(a);
  return b;
}, glCullFace:function(a) {
  Z.cullFace(a);
}, glDeleteBuffers:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = I[b + 4 * c >> 2], e = wd[d];
    e && (Z.deleteBuffer(e), e.name = 0, wd[d] = null, d == Z.Pa && (Z.Pa = 0), d == Z.Qa && (Z.Qa = 0));
  }
}, glDeleteFramebuffers:function(a, b) {
  for (var c = 0; c < a; ++c) {
    var d = I[b + 4 * c >> 2], e = xd[d];
    e && (Z.deleteFramebuffer(e), e.name = 0, xd[d] = null);
  }
}, glDeleteProgram:function(a) {
  if (a) {
    var b = X[a];
    b ? (Z.deleteProgram(b), b.name = 0, X[a] = null) : Y(1281);
  }
}, glDeleteRenderbuffers:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = I[b + 4 * c >> 2], e = yd[d];
    e && (Z.deleteRenderbuffer(e), e.name = 0, yd[d] = null);
  }
}, glDeleteShader:function(a) {
  if (a) {
    var b = Ad[a];
    b ? (Z.deleteShader(b), Ad[a] = null) : Y(1281);
  }
}, glDeleteTextures:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = I[b + 4 * c >> 2], e = zd[d];
    e && (Z.deleteTexture(e), e.name = 0, zd[d] = null);
  }
}, glDeleteVertexArrays:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = I[b + 4 * c >> 2];
    Z.deleteVertexArray(Bd[d]);
    Bd[d] = null;
  }
}, glDepthFunc:function(a) {
  Z.depthFunc(a);
}, glDepthMask:function(a) {
  Z.depthMask(!!a);
}, glDepthRangef:function(a, b) {
  Z.depthRange(a, b);
}, glDisable:function(a) {
  Z.disable(a);
}, glDrawArrays:function(a, b, c) {
  Z.drawArrays(a, b, c);
}, glDrawArraysInstanced:function(a, b, c, d) {
  Z.drawArraysInstanced(a, b, c, d);
}, glDrawBuffers:function(a, b) {
  for (var c = Kd[a], d = 0; d < a; d++) {
    c[d] = I[b + 4 * d >> 2];
  }
  Z.drawBuffers(c);
}, glDrawElements:function(a, b, c, d) {
  Z.drawElements(a, b, c, d);
}, glDrawElementsInstanced:function(a, b, c, d, e) {
  Z.drawElementsInstanced(a, b, c, d, e);
}, glEnable:function(a) {
  Z.enable(a);
}, glEnableVertexAttribArray:function(a) {
  Z.enableVertexAttribArray(a);
}, glFlush:function() {
  Z.flush();
}, glFramebufferRenderbuffer:function(a, b, c, d) {
  Z.framebufferRenderbuffer(a, b, c, yd[d]);
}, glFramebufferTexture2D:function(a, b, c, d, e) {
  Z.framebufferTexture2D(a, b, c, zd[d], e);
}, glFrontFace:function(a) {
  Z.frontFace(a);
}, glGenBuffers:function(a, b) {
  Ld(a, b, "createBuffer", wd);
}, glGenFramebuffers:function(a, b) {
  Ld(a, b, "createFramebuffer", xd);
}, glGenRenderbuffers:function(a, b) {
  Ld(a, b, "createRenderbuffer", yd);
}, glGenTextures:function(a, b) {
  Ld(a, b, "createTexture", zd);
}, glGenVertexArrays:function(a, b) {
  Ld(a, b, "createVertexArray", Bd);
}, glGenerateMipmap:function(a) {
  Z.generateMipmap(a);
}, glGetError:function() {
  var a = Z.getError() || Dd;
  Dd = 0;
  return a;
}, glGetIntegerv:function(a, b) {
  Md(a, b);
}, glGetProgramiv:function(a, b, c) {
  if (c) {
    if (a >= vd) {
      Y(1281);
    } else {
      if (a = X[a], 35716 == b) {
        a = Z.getProgramInfoLog(a), null === a && (a = "(unknown error)"), I[c >> 2] = a.length + 1;
      } else if (35719 == b) {
        if (!a.Ba) {
          for (b = 0; b < Z.getProgramParameter(a, 35718); ++b) {
            a.Ba = Math.max(a.Ba, Z.getActiveUniform(a, b).name.length + 1);
          }
        }
        I[c >> 2] = a.Ba;
      } else if (35722 == b) {
        if (!a.za) {
          for (b = 0; b < Z.getProgramParameter(a, 35721); ++b) {
            a.za = Math.max(a.za, Z.getActiveAttrib(a, b).name.length + 1);
          }
        }
        I[c >> 2] = a.za;
      } else if (35381 == b) {
        if (!a.Aa) {
          for (b = 0; b < Z.getProgramParameter(a, 35382); ++b) {
            a.Aa = Math.max(a.Aa, Z.getActiveUniformBlockName(a, b).length + 1);
          }
        }
        I[c >> 2] = a.Aa;
      } else {
        I[c >> 2] = Z.getProgramParameter(a, b);
      }
    }
  } else {
    Y(1281);
  }
}, glGetString:function(a) {
  var b = Cd[a];
  if (!b) {
    switch(a) {
      case 7939:
        b = Z.getSupportedExtensions() || [];
        b = b.concat(b.map(function(d) {
          return "GL_" + d;
        }));
        b = Od(b.join(" "));
        break;
      case 7936:
      case 7937:
      case 37445:
      case 37446:
        (b = Z.getParameter(a)) || Y(1280);
        b = b && Od(b);
        break;
      case 7938:
        b = Od("OpenGL ES 3.0 (" + Z.getParameter(7938) + ")");
        break;
      case 35724:
        b = Z.getParameter(35724);
        var c = b.match(/^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/);
        null !== c && (3 == c[1].length && (c[1] += "0"), b = "OpenGL ES GLSL ES " + c[1] + " (" + b + ")");
        b = Od(b);
        break;
      default:
        Y(1280);
    }
    Cd[a] = b;
  }
  return b;
}, glGetUniformBlockIndex:function(a, b) {
  return Z.getUniformBlockIndex(X[a], b ? M(F, b) : "");
}, glGetUniformLocation:function(a, b) {
  b = b ? M(F, b) : "";
  if (a = X[a]) {
    var c = a, d = c.oa, e = c.zb, f;
    if (!d) {
      for (c.oa = d = {}, c.yb = {}, f = 0; f < Z.getProgramParameter(c, 35718); ++f) {
        var g = Z.getActiveUniform(c, f);
        var l = g.name;
        g = g.size;
        var p = Pd(l);
        p = 0 < p ? l.slice(0, p) : l;
        var m = c.Ya;
        c.Ya += g;
        e[p] = [g, m];
        for (l = 0; l < g; ++l) {
          d[m] = l, c.yb[m++] = p;
        }
      }
    }
    c = a.oa;
    d = 0;
    e = b;
    f = Pd(b);
    0 < f && (d = parseInt(b.slice(f + 1)) >>> 0, e = b.slice(0, f));
    if ((e = a.zb[e]) && d < e[0] && (d += e[1], c[d] = c[d] || Z.getUniformLocation(a, b))) {
      return d;
    }
  } else {
    Y(1281);
  }
  return -1;
}, glInvalidateFramebuffer:function(a, b, c) {
  for (var d = Kd[b], e = 0; e < b; e++) {
    d[e] = I[c + 4 * e >> 2];
  }
  Z.invalidateFramebuffer(a, d);
}, glLinkProgram:function(a) {
  a = X[a];
  Z.linkProgram(a);
  a.oa = 0;
  a.zb = {};
}, glPixelStorei:function(a, b) {
  Z.pixelStorei(a, b);
}, glReadPixels:function(a, b, c, d, e, f, g) {
  if (Z.Pa) {
    Z.readPixels(a, b, c, d, e, f, g);
  } else {
    var l = Qd(f);
    Z.readPixels(a, b, c, d, e, f, l, g >> 31 - Math.clz32(l.BYTES_PER_ELEMENT));
  }
}, glRenderbufferStorageMultisample:function(a, b, c, d, e) {
  Z.renderbufferStorageMultisample(a, b, c, d, e);
}, glScissor:function(a, b, c, d) {
  Z.scissor(a, b, c, d);
}, glShaderSource:function(a, b, c, d) {
  for (var e = "", f = 0; f < b; ++f) {
    var g = d ? I[d + 4 * f >> 2] : -1, l = I[c + 4 * f >> 2];
    g = l ? M(F, l, 0 > g ? void 0 : g) : "";
    e += g;
  }
  Z.shaderSource(Ad[a], e);
}, glStencilFunc:function(a, b, c) {
  Z.stencilFunc(a, b, c);
}, glStencilFuncSeparate:function(a, b, c, d) {
  Z.stencilFuncSeparate(a, b, c, d);
}, glStencilMask:function(a) {
  Z.stencilMask(a);
}, glStencilOp:function(a, b, c) {
  Z.stencilOp(a, b, c);
}, glStencilOpSeparate:function(a, b, c, d) {
  Z.stencilOpSeparate(a, b, c, d);
}, glTexParameteri:function(a, b, c) {
  Z.texParameteri(a, b, c);
}, glTexStorage2D:function(a, b, c, d, e) {
  Z.texStorage2D(a, b, c, d, e);
}, glTexSubImage2D:function(a, b, c, d, e, f, g, l, p) {
  if (Z.Qa) {
    Z.texSubImage2D(a, b, c, d, e, f, g, l, p);
  } else if (p) {
    var m = Qd(l);
    Z.texSubImage2D(a, b, c, d, e, f, g, l, m, p >> 31 - Math.clz32(m.BYTES_PER_ELEMENT));
  } else {
    Z.texSubImage2D(a, b, c, d, e, f, g, l, null);
  }
}, glUniform1i:function(a, b) {
  var c = Z, d = c.uniform1i;
  var e = Z.Kb;
  if (e) {
    var f = e.oa[a];
    "number" == typeof f && (e.oa[a] = f = Z.getUniformLocation(e, e.yb[a] + (0 < f ? "[" + f + "]" : "")));
    a = f;
  } else {
    Y(1282), a = void 0;
  }
  d.call(c, a, b);
}, glUniformBlockBinding:function(a, b, c) {
  a = X[a];
  Z.uniformBlockBinding(a, b, c);
}, glUseProgram:function(a) {
  a = X[a];
  Z.useProgram(a);
  Z.Kb = a;
}, glVertexAttribDivisor:function(a, b) {
  Z.vertexAttribDivisor(a, b);
}, glVertexAttribIPointer:function(a, b, c, d, e) {
  Z.vertexAttribIPointer(a, b, c, d, e);
}, glVertexAttribPointer:function(a, b, c, d, e, f) {
  Z.vertexAttribPointer(a, b, c, !!d, e, f);
}, glViewport:function(a, b, c, d) {
  Z.viewport(a, b, c, d);
}, provokingVertexWEBGL:function(a, b) {
  (a = w[a].C.rb) && a.provokingVertexWEBGL(b);
}, strftime_l:(a, b, c, d) => Ud(a, b, c, d), upload_image:function(a, b) {
  var c = k.images;
  c && (b = c.get(b)) && (a = w[a].C, a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, b), a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1));
}};
(function() {
  function a(c) {
    C = c = c.exports;
    ua = C.memory;
    za();
    Aa = C.__indirect_function_table;
    Ca.unshift(C.__wasm_call_ctors);
    Fa--;
    k.monitorRunDependencies && k.monitorRunDependencies(Fa);
    if (0 == Fa && (null !== Ga && (clearInterval(Ga), Ga = null), Ha)) {
      var d = Ha;
      Ha = null;
      d();
    }
    return c;
  }
  var b = {env:Zd, wasi_snapshot_preview1:Zd,};
  Fa++;
  k.monitorRunDependencies && k.monitorRunDependencies(Fa);
  if (k.instantiateWasm) {
    try {
      return k.instantiateWasm(b, a);
    } catch (c) {
      ra("Module.instantiateWasm callback failed with error: " + c), ca(c);
    }
  }
  Oa(b, function(c) {
    a(c.instance);
  }).catch(ca);
  return {};
})();
var nc = a => (nc = C.free)(a), Nd = a => (Nd = C.malloc)(a);
k._setWebImage = (a, b, c) => (k._setWebImage = C.setWebImage)(a, b, c);
var Yd = () => (Yd = C.__errno_location)(), Ra = k._ma_device__on_notification_unlocked = a => (Ra = k._ma_device__on_notification_unlocked = C.ma_device__on_notification_unlocked)(a);
k._ma_malloc_emscripten = (a, b) => (k._ma_malloc_emscripten = C.ma_malloc_emscripten)(a, b);
k._ma_free_emscripten = (a, b) => (k._ma_free_emscripten = C.ma_free_emscripten)(a, b);
var Sa = k._ma_device_process_pcm_frames_capture__webaudio = (a, b, c) => (Sa = k._ma_device_process_pcm_frames_capture__webaudio = C.ma_device_process_pcm_frames_capture__webaudio)(a, b, c), Ta = k._ma_device_process_pcm_frames_playback__webaudio = (a, b, c) => (Ta = k._ma_device_process_pcm_frames_playback__webaudio = C.ma_device_process_pcm_frames_playback__webaudio)(a, b, c), mc = a => (mc = C.__getTypeName)(a);
k.__embind_initialize_bindings = () => (k.__embind_initialize_bindings = C._embind_initialize_bindings)();
k.dynCall_iiiji = (a, b, c, d, e, f) => (k.dynCall_iiiji = C.dynCall_iiiji)(a, b, c, d, e, f);
k.dynCall_iij = (a, b, c, d) => (k.dynCall_iij = C.dynCall_iij)(a, b, c, d);
k.dynCall_iiji = (a, b, c, d, e) => (k.dynCall_iiji = C.dynCall_iiji)(a, b, c, d, e);
k.dynCall_jii = (a, b, c) => (k.dynCall_jii = C.dynCall_jii)(a, b, c);
k.dynCall_vijj = (a, b, c, d, e, f) => (k.dynCall_vijj = C.dynCall_vijj)(a, b, c, d, e, f);
k.dynCall_jiji = (a, b, c, d, e) => (k.dynCall_jiji = C.dynCall_jiji)(a, b, c, d, e);
k.dynCall_viijii = (a, b, c, d, e, f, g) => (k.dynCall_viijii = C.dynCall_viijii)(a, b, c, d, e, f, g);
k.dynCall_iiiiij = (a, b, c, d, e, f, g) => (k.dynCall_iiiiij = C.dynCall_iiiiij)(a, b, c, d, e, f, g);
k.dynCall_iiiiijj = (a, b, c, d, e, f, g, l, p) => (k.dynCall_iiiiijj = C.dynCall_iiiiijj)(a, b, c, d, e, f, g, l, p);
k.dynCall_iiiiiijj = (a, b, c, d, e, f, g, l, p, m) => (k.dynCall_iiiiiijj = C.dynCall_iiiiiijj)(a, b, c, d, e, f, g, l, p, m);
k.___start_em_js = 532308;
k.___stop_em_js = 535063;
var $d;
Ha = function ae() {
  $d || be();
  $d || (Ha = ae);
};
function be() {
  function a() {
    if (!$d && ($d = !0, k.calledRun = !0, !va)) {
      k.noFSInit || Tb || (Tb = !0, Sb(), k.stdin = k.stdin, k.stdout = k.stdout, k.stderr = k.stderr, k.stdin ? Vb("stdin", k.stdin) : Ob("/dev/tty", "/dev/stdin"), k.stdout ? Vb("stdout", null, k.stdout) : Ob("/dev/tty", "/dev/stdout"), k.stderr ? Vb("stderr", null, k.stderr) : Ob("/dev/tty1", "/dev/stderr"), Qb("/dev/stdin", 0), Qb("/dev/stdout", 1), Qb("/dev/stderr", 1));
      zb = !1;
      Va(Ca);
      aa(k);
      if (k.onRuntimeInitialized) {
        k.onRuntimeInitialized();
      }
      if (k.postRun) {
        for ("function" == typeof k.postRun && (k.postRun = [k.postRun]); k.postRun.length;) {
          var b = k.postRun.shift();
          Da.unshift(b);
        }
      }
      Va(Da);
    }
  }
  if (!(0 < Fa)) {
    if (k.preRun) {
      for ("function" == typeof k.preRun && (k.preRun = [k.preRun]); k.preRun.length;) {
        Ea();
      }
    }
    Va(Ba);
    0 < Fa || (k.setStatus ? (k.setStatus("Running..."), setTimeout(function() {
      setTimeout(function() {
        k.setStatus("");
      }, 1);
      a();
    }, 1)) : a());
  }
}
if (k.preInit) {
  for ("function" == typeof k.preInit && (k.preInit = [k.preInit]); 0 < k.preInit.length;) {
    k.preInit.pop()();
  }
}
be();



  return moduleArg.ready
}

);
})();
export default Rive;